(function () {

	var cookieData	=	$('html').data('cookie'),
		currPepres	=	document.cookie.replace(/(?:(?:^|.*;\s*)pepres\s*\=\s*([^;]*).*$)|^.*$/, "$1");//,
		//now			=	new Date(),
		//expire		=	new Date(now.getTime() + (parseInt(cookieData.timeout, 10) * 10000));

	if (cookieData && parseInt(currPepres, 10) !== Math.max(screen.width,screen.height)) {

		document.cookie = 'pepres=' + Math.max(screen.width,screen.height) + '; path=' + cookieData.b + '; ' + cookieData.s + '; ' + cookieData.h;

	}

})();









/*! modernizr 3.5.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-cssanimations-cssgrid_cssgridlegacy-csstransforms-csstransforms3d-csstransitions-fontface-inlinesvg-json-localstorage-lowbandwidth-mediaqueries-postmessage-requestanimationframe-svg-svgasimg-svgclippaths-svgfilters-touchevents-prefixed-prefixedcss-setclasses !*/
!function(e,t,n){function r(e){return e.replace(/([A-Z])/g,function(e,t){return"-"+t.toLowerCase()}).replace(/^ms-/,"-ms-")}function s(e){var t=_.className,n=Modernizr._config.classPrefix||"";if(x&&(t=t.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");t=t.replace(r,"$1"+n+"js$2")}Modernizr._config.enableClasses&&(t+=" "+n+e.join(" "+n),x?_.className.baseVal=t:_.className=t)}function i(e){return e.replace(/([a-z])-([a-z])/g,function(e,t,n){return t+n.toUpperCase()}).replace(/^-/,"")}function o(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):x?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function a(e,t){return typeof e===t}function l(){var e,t,n,r,s,i,o;for(var l in C)if(C.hasOwnProperty(l)){if(e=[],t=C[l],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(n=0;n<t.options.aliases.length;n++)e.push(t.options.aliases[n].toLowerCase());for(r=a(t.fn,"function")?t.fn():t.fn,s=0;s<e.length;s++)i=e[s],o=i.split("."),1===o.length?Modernizr[o[0]]=r:(!Modernizr[o[0]]||Modernizr[o[0]]instanceof Boolean||(Modernizr[o[0]]=new Boolean(Modernizr[o[0]])),Modernizr[o[0]][o[1]]=r),w.push((r?"":"no-")+o.join("-"))}}function u(e,t){if("object"==typeof e)for(var n in e)N(e,n)&&u(n,e[n]);else{e=e.toLowerCase();var r=e.split("."),i=Modernizr[r[0]];if(2==r.length&&(i=i[r[1]]),"undefined"!=typeof i)return Modernizr;t="function"==typeof t?t():t,1==r.length?Modernizr[r[0]]=t:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=t),s([(t&&0!=t?"":"no-")+r.join("-")]),Modernizr._trigger(e,t)}return Modernizr}function f(){var e=t.body;return e||(e=o(x?"svg":"body"),e.fake=!0),e}function c(e,n,r,s){var i,a,l,u,c="modernizr",d=o("div"),p=f();if(parseInt(r,10))for(;r--;)l=o("div"),l.id=s?s[r]:c+(r+1),d.appendChild(l);return i=o("style"),i.type="text/css",i.id="s"+c,(p.fake?p:d).appendChild(i),p.appendChild(d),i.styleSheet?i.styleSheet.cssText=e:i.appendChild(t.createTextNode(e)),d.id=c,p.fake&&(p.style.background="",p.style.overflow="hidden",u=_.style.overflow,_.style.overflow="hidden",_.appendChild(p)),a=n(d,e),p.fake?(p.parentNode.removeChild(p),_.style.overflow=u,_.offsetHeight):d.parentNode.removeChild(d),!!a}function d(e,t){return!!~(""+e).indexOf(t)}function p(e,t){return function(){return e.apply(t,arguments)}}function m(e,t,n){var r;for(var s in e)if(e[s]in t)return n===!1?e[s]:(r=t[e[s]],a(r,"function")?p(r,n||t):r);return!1}function g(t,n,r){var s;if("getComputedStyle"in e){s=getComputedStyle.call(e,t,n);var i=e.console;if(null!==s)r&&(s=s.getPropertyValue(r));else if(i){var o=i.error?"error":"log";i[o].call(i,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else s=!n&&t.currentStyle&&t.currentStyle[r];return s}function h(t,s){var i=t.length;if("CSS"in e&&"supports"in e.CSS){for(;i--;)if(e.CSS.supports(r(t[i]),s))return!0;return!1}if("CSSSupportsRule"in e){for(var o=[];i--;)o.push("("+r(t[i])+":"+s+")");return o=o.join(" or "),c("@supports ("+o+") { #modernizr { position: absolute; } }",function(e){return"absolute"==g(e,null,"position")})}return n}function v(e,t,r,s){function l(){f&&(delete k.style,delete k.modElem)}if(s=a(s,"undefined")?!1:s,!a(r,"undefined")){var u=h(e,r);if(!a(u,"undefined"))return u}for(var f,c,p,m,g,v=["modernizr","tspan","samp"];!k.style&&v.length;)f=!0,k.modElem=o(v.shift()),k.style=k.modElem.style;for(p=e.length,c=0;p>c;c++)if(m=e[c],g=k.style[m],d(m,"-")&&(m=i(m)),k.style[m]!==n){if(s||a(r,"undefined"))return l(),"pfx"==t?m:!0;try{k.style[m]=r}catch(y){}if(k.style[m]!=g)return l(),"pfx"==t?m:!0}return l(),!1}function y(e,t,n,r,s){var i=e.charAt(0).toUpperCase()+e.slice(1),o=(e+" "+V.join(i+" ")+i).split(" ");return a(t,"string")||a(t,"undefined")?v(o,t,r,s):(o=(e+" "+L.join(i+" ")+i).split(" "),m(o,t,n))}function S(e,t,r){return y(e,n,n,t,r)}var w=[],C=[],T={_version:"3.5.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var n=this;setTimeout(function(){t(n[e])},0)},addTest:function(e,t,n){C.push({name:e,fn:t,options:n})},addAsyncTest:function(e){C.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=T,Modernizr=new Modernizr,Modernizr.addTest("json","JSON"in e&&"parse"in JSON&&"stringify"in JSON),Modernizr.addTest("postmessage","postMessage"in e),Modernizr.addTest("svg",!!t.createElementNS&&!!t.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect),Modernizr.addTest("lowbandwidth",function(){var e=navigator.connection||{type:0};return 3==e.type||4==e.type||/^[23]g$/.test(e.type)}),Modernizr.addTest("localstorage",function(){var e="modernizr";try{return localStorage.setItem(e,e),localStorage.removeItem(e),!0}catch(t){return!1}}),Modernizr.addTest("svgfilters",function(){var t=!1;try{t="SVGFEColorMatrixElement"in e&&2==SVGFEColorMatrixElement.SVG_FECOLORMATRIX_TYPE_SATURATE}catch(n){}return t});var _=t.documentElement,x="svg"===_.nodeName.toLowerCase(),b=T._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];T._prefixes=b;var E="CSS"in e&&"supports"in e.CSS,P="supportsCSS"in e;Modernizr.addTest("supports",E||P);var z={}.toString;Modernizr.addTest("svgclippaths",function(){return!!t.createElementNS&&/SVGClipPath/.test(z.call(t.createElementNS("http://www.w3.org/2000/svg","clipPath")))}),Modernizr.addTest("inlinesvg",function(){var e=o("div");return e.innerHTML="<svg/>","http://www.w3.org/2000/svg"==("undefined"!=typeof SVGRect&&e.firstChild&&e.firstChild.namespaceURI)});var N;!function(){var e={}.hasOwnProperty;N=a(e,"undefined")||a(e.call,"undefined")?function(e,t){return t in e&&a(e.constructor.prototype[t],"undefined")}:function(t,n){return e.call(t,n)}}(),T._l={},T.on=function(e,t){this._l[e]||(this._l[e]=[]),this._l[e].push(t),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e])},0)},T._trigger=function(e,t){if(this._l[e]){var n=this._l[e];setTimeout(function(){var e,r;for(e=0;e<n.length;e++)(r=n[e])(t)},0),delete this._l[e]}},Modernizr._q.push(function(){T.addTest=u}),Modernizr.addTest("svgasimg",t.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image","1.1"));var R=T.testStyles=c;Modernizr.addTest("touchevents",function(){var n;if("ontouchstart"in e||e.DocumentTouch&&t instanceof DocumentTouch)n=!0;else{var r=["@media (",b.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");R(r,function(e){n=9===e.offsetTop})}return n});var O=function(){var e=navigator.userAgent,t=e.match(/w(eb)?osbrowser/gi),n=e.match(/windows phone/gi)&&e.match(/iemobile\/([0-9])+/gi)&&parseFloat(RegExp.$1)>=9;return t||n}();O?Modernizr.addTest("fontface",!1):R('@font-face {font-family:"font";src:url("https://")}',function(e,n){var r=t.getElementById("smodernizr"),s=r.sheet||r.styleSheet,i=s?s.cssRules&&s.cssRules[0]?s.cssRules[0].cssText:s.cssText||"":"",o=/src/i.test(i)&&0===i.indexOf(n.split(" ")[0]);Modernizr.addTest("fontface",o)});var A=function(){var t=e.matchMedia||e.msMatchMedia;return t?function(e){var n=t(e);return n&&n.matches||!1}:function(t){var n=!1;return c("@media "+t+" { #modernizr { position: absolute; } }",function(t){n="absolute"==(e.getComputedStyle?e.getComputedStyle(t,null):t.currentStyle).position}),n}}();T.mq=A,Modernizr.addTest("mediaqueries",A("only all"));var j="Moz O ms Webkit",V=T._config.usePrefixes?j.split(" "):[];T._cssomPrefixes=V;var q=function(t){var r,s=b.length,i=e.CSSRule;if("undefined"==typeof i)return n;if(!t)return!1;if(t=t.replace(/^@/,""),r=t.replace(/-/g,"_").toUpperCase()+"_RULE",r in i)return"@"+t;for(var o=0;s>o;o++){var a=b[o],l=a.toUpperCase()+"_"+r;if(l in i)return"@-"+a.toLowerCase()+"-"+t}return!1};T.atRule=q;var L=T._config.usePrefixes?j.toLowerCase().split(" "):[];T._domPrefixes=L;var M={elem:o("modernizr")};Modernizr._q.push(function(){delete M.elem});var k={style:M.elem.style};Modernizr._q.unshift(function(){delete k.style}),T.testAllProps=y;var I=T.prefixed=function(e,t,n){return 0===e.indexOf("@")?q(e):(-1!=e.indexOf("-")&&(e=i(e)),t?y(e,t,n):y(e,"pfx"))};T.prefixedCSS=function(e){var t=I(e);return t&&r(t)};Modernizr.addTest("requestanimationframe",!!I("requestAnimationFrame",e),{aliases:["raf"]}),T.testAllProps=S,Modernizr.addTest("cssanimations",S("animationName","a",!0)),Modernizr.addTest("cssgridlegacy",S("grid-columns","10px",!0)),Modernizr.addTest("cssgrid",S("grid-template-rows","none",!0)),Modernizr.addTest("csstransforms",function(){return-1===navigator.userAgent.indexOf("Android 2.")&&S("transform","scale(1)",!0)}),Modernizr.addTest("csstransforms3d",function(){var e=!!S("perspective","1px",!0),t=Modernizr._config.usePrefixes;if(e&&(!t||"webkitPerspective"in _.style)){var n,r="#modernizr{width:0;height:0}";Modernizr.supports?n="@supports (perspective: 1px)":(n="@media (transform-3d)",t&&(n+=",(-webkit-transform-3d)")),n+="{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}",R(r+n,function(t){e=7===t.offsetWidth&&18===t.offsetHeight})}return e}),Modernizr.addTest("csstransitions",S("transition","all",!0)),l(),s(w),delete T.addTest,delete T.addAsyncTest;for(var G=0;G<Modernizr._q.length;G++)Modernizr._q[G]();e.Modernizr=Modernizr}(window,document);










/**
 *	Tracks JS errors and sends a report to the server.
 */
(function () {

	function trackError(error, fieldsObj) {

		var errorDefaults	=	{
				event_category	:	'Script',
				event_action		:	'error',
				description		:	(error && error.stack) || '(not set)',
				nonInteraction	:	true
			},
			options			=	$.extend(errorDefaults, fieldsObj);

		if (typeof gtag !== 'undefined')	gtag('event', 'exception', options);

	}

	function trackErrors() {

		var loadErrorEvents	=	window.__e && window.__e.q || [],
			fieldsObj		=	{
				event_action	:	'uncaught error'
			};

		// Replay any stored load error events.
		for (var index in loadErrorEvents) {

			trackError(loadErrorEvents[index].error, fieldsObj);

		}

		// Add a new listener to track event immediately.
		window.addEventListener('error', function (event) {

			trackError(event.error, fieldsObj);

		});

	}

	$(trackErrors);

	window.onerror	=	function (message, source, lineno, colno, error) {

		if (typeof message === 'undefined')	var message	=	'';
		if (typeof source === 'undefined')	var source	=	'';
		if (typeof lineno === 'undefined')	var lineno	=	0;
		if (typeof colno === 'undefined')	var colno	=	0;

		var stack	=	'';

		if (typeof error === 'object' && typeof error.stack === 'string')	stack	=	error.stack;

		$.ajax({
			url			:	'/library/api/capture-js-error.php',
			type		:	'post',
			dataType	:	'json',
			data		:	{
				je_message	:	message,
				je_source	:	source,
				je_lineno	:	lineno,
				je_colno	:	colno,
				je_url		:	window.location.href,
				je_stack	:	stack
			}
		});

	};

})(jQuery, window);

require('./pepHelperFunctions');

window.pepConsole = {
  isDev: ('dev.' === location.hostname.substr(0, 4)),
  log: function () {
    if (window.pepConsole.isDev) {
      console.log.apply(window, arguments);
    }
  },
  group: function () {
    if (window.pepConsole.isDev) {
      console.group.apply(window, arguments);
    }
  },
  groupEnd: function () {
    if (window.pepConsole.isDev) {
      console.groupEnd.apply(window, arguments);
    }
  }
};

require('./pepDateFunctions');


//add global easing method
jQuery.easing['jswing'] = jQuery.easing['swing'];
jQuery.extend( jQuery.easing,
{
	easeInCubic: function (x, t, b, c, d) {
		return c*(t/=d)*t*t + b;
	},
	easeOutCubic: function (x, t, b, c, d) {
		return c*((t=t/d-1)*t*t + 1) + b;
	},
	easeInOutCubic: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t + b;
		return c/2*((t-=2)*t*t + 2) + b;
	}
});




(function($) {

var types = ['DOMMouseScroll', 'mousewheel'];

if ($.event.fixHooks) {
    for ( var i=types.length; i; ) {
        $.event.fixHooks[ types[--i] ] = $.event.mouseHooks;
    }
}

$.event.special.mousewheel = {
    setup: function() {
        if ( this.addEventListener ) {
            for ( var i=types.length; i; ) {
                this.addEventListener( types[--i], handler, false );
            }
        } else {
            this.onmousewheel = handler;
        }
    },

    teardown: function() {
        if ( this.removeEventListener ) {
            for ( var i=types.length; i; ) {
                this.removeEventListener( types[--i], handler, false );
            }
        } else {
            this.onmousewheel = null;
        }
    }
};

$.fn.extend({
    mousewheel: function(fn) {
        return fn ? this.bind("mousewheel", fn) : this.trigger("mousewheel");
    },

    unmousewheel: function(fn) {
        return this.unbind("mousewheel", fn);
    }
});


function handler(event) {
    var orgEvent = event || window.event, args = [].slice.call( arguments, 1 ), delta = 0, returnValue = true, deltaX = 0, deltaY = 0;
    event = $.event.fix(orgEvent);
    event.type = "mousewheel";

    // Old school scrollwheel delta
    if ( orgEvent.wheelDelta ) { delta = orgEvent.wheelDelta/120; }
    if ( orgEvent.detail     ) { delta = -orgEvent.detail/3; }

    // New school multidimensional scroll (touchpads) deltas
    deltaY = delta;

    // Gecko
    if ( orgEvent.axis !== undefined && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
        deltaY = 0;
        deltaX = -1*delta;
    }

    // Webkit
    if ( orgEvent.wheelDeltaY !== undefined ) { deltaY = orgEvent.wheelDeltaY/120; }
    if ( orgEvent.wheelDeltaX !== undefined ) { deltaX = -1*orgEvent.wheelDeltaX/120; }

    // Add event and delta to the front of the arguments
    args.unshift(event, delta, deltaX, deltaY);

    return ($.event.dispatch || $.event.handle).apply(this, args);
}

})(jQuery);









/*! jQuery requestAnimationFrame - v0.1.2 - 2013-04-15
* https://github.com/gnarf37/jquery-requestAnimationFrame
* Copyright (c) 2013 Corey Frang; Licensed MIT */
(function(e){function o(){t&&(i(o),jQuery.fx.tick())}var t,n=0,r=["webkit","moz"],i=window.requestAnimationFrame,s=window.cancelAnimationFrame;for(;n<r.length&&!i;n++)i=window[r[n]+"RequestAnimationFrame"],s=s||window[r[n]+"CancelAnimationFrame"]||window[r[n]+"CancelRequestAnimationFrame"];i?(window.requestAnimationFrame=i,window.cancelAnimationFrame=s,jQuery.fx.timer=function(e){e()&&jQuery.timers.push(e)&&!t&&(t=!0,o())},jQuery.fx.stop=function(){t=!1}):(window.requestAnimationFrame=function(e,t){var r=(new Date).getTime(),i=Math.max(0,16-(r-n)),s=window.setTimeout(function(){e(r+i)},i);return n=r+i,s},window.cancelAnimationFrame=function(e){clearTimeout(e)})})(jQuery);











//requestAnimationFrame browser extensions / fallback
(function() {
	var lastTime = 0;
	var vendors = ['ms', 'moz', 'webkit', 'o'];
	for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
		window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
		window.cancelAnimationFrame =
		  window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
	}

	if (!window.requestAnimationFrame)
		window.requestAnimationFrame = function(callback, element) {
			var currTime = new Date().getTime();
			var timeToCall = Math.max(0, 16 - (currTime - lastTime));
			var id = window.setTimeout(function() { callback(currTime + timeToCall); },
			  timeToCall);
			lastTime = currTime + timeToCall;
			return id;
		};

	if (!window.cancelAnimationFrame)
		window.cancelAnimationFrame = function(id) {
			clearTimeout(id);
		};
}());





;(function() {

	if (typeof $.fn.onCSSTransitionEnd === 'function')	return;

	var s					=	document.body || document.documentElement, s = s.style, prefixAnimation = '', prefixTransition = '', eventAnimation = 'animationend', eventTransition = 'transitionend',
		transEndEventNames	=	{
			'WebkitTransition' : 'webkitTransitionEnd',
			'MozTransition'    : 'transitionend',
			'transition'       : 'transitionend'
		},
		transEndEventName	=	transEndEventNames[ Modernizr.prefixed('transition') ],
		transCSS			=	Modernizr.prefixedCSS('transition');

	$.fn.extend({
		onCSSAnimationEnd: function(callback) {

			var $this	=	$( this );

			$this.one( eventAnimation, callback);

			if( ( prefixAnimation == '' && !( 'animation' in s ) ) || $this.css( prefixAnimation + 'animation-duration' ) == '0s' ) $.each($this, callback);

			return this;

		},
		onCSSTransitionEnd: function(callback) {

			var $this = $( this );

			if (typeof transEndEventName !== 'string' || ($this.css( transCSS + '-duration' ) === '0s' && $this.css( transCSS + '-delay' ) === '0s') ) {

				$.each($this, callback);

			} else {

				$this.one( eventTransition, callback );

			}

			return this;

		}
	});
})();











/*!
 * Copyright (C) 2013-2024, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 * PeppermillReno.com Custom JS - 3/4/2013
 * Version: 1.2.6
 * Changes:
 *		2016-02-25
 *			- Initial Install
 *
 *		2016-08-02
 *			- Added code for fullscreen button in the gallery.
 *
 *		2016-08-03
 *			- Gallery images now don't display larger than their actual size.
 *			- Query-string data is now discarded when checking if URLs patch when changing pages.
 *
 *		2017-01-06 (1.1.1)
 *			- When using PRIVLINE offer code in Reservation Widget, a company code is required to be forwarded to ResNet.
 *				- A dialog is used to gather this information.
 *			- Fixed GA Linker for links that point to /offers and /choose-a-room as well as the Header Reseration Widget
 *
 *		2017-01-17 (1.1.2)
 *			- If a menu iframe does not load in 10 seconds, a dialog will appear asking if the user wants to directly download the PDF.
 *				- This is to get around the corporate network blocking Google Drive.
 *
 *		2017-01-23 (1.1.3)
 *			- Videos are paused when the reservations/login/menu overlays are visible.
 *
 *		2017-01-25 (1.1.4)
 *			- Menus are now loaded as a PDF by default for non touch-enabled devices and for devices on the corporate network.
 *			- The Outlet Hours API is not hit unless there are potential .item matches on the page.
 *			- Dialogs shown with pepvalidate-v3 forms will now correctly submit the dialog rather than the pepvalidate-v3 form when <ENTER> is pressed inside an input or textarea.
 *
 *		2017-01-30 (1.1.5)
 *			- Removed CSRF_TOKEN and honeypot from search queries.
 *
 *		2017-01-31 (1.1.6)
 *			- Added code to handle table pagination.
 *
 *		2017-02-14 (1.1.7)
 *			- Passport Header login successes and failures now send event tracking beacons.
 *
 *		2017-02-21 (1.1.8)
 *			- Updated Confirmation Dialogs for better accessibility via tabindex.
 *			- Fixed various bugs in page link filters.
 *			- Page link filters now adjust the count for each option when opening a flyout menu.
 *
 *		2017-03-03 (1.1.9)
 *			- Updated video controls.
 *			- Fixed positioning of artwork dot overlays when not shown full-width.
 *
 *		2017-03-06 (1.1.10)
 *			- Flash video tech now loads in wmode transparent with a transparent background so there's no flash of black before the video plays.
 *
 *		2017-03-31 (1.1.11)
 *			- Fixed outlet hours not appending to .item h3 titles because the .clip span had been removed.
 *
 *		2017-06-27 (1.1.12)
 *			- Fixed issue with the footer opacity as it's first being shown.
 *
 *		2017-07-11 (1.1.13)
 *			- Changes to inputs in the reservation widget in the header are now saved across page loads for 30 minutes.
 *
 *		2017-07-18 (1.1.14)
 *			- Added code to redirect to WiFi portal for wifi nav link.
 *
 *		2017-09-12 (1.1.15)
 *			- Updated .page-link-subnav link clicks to reset focus on section header for accessibility.
 *			- Do not show outlet hour notifications for .related-event page links.
 *			- Fixed issue with related event iframes not being resized in Firefox.
 *
 *		2018-01-11 (1.1.16)
 *			- Subnav link clicks are now tracked in GA.
 *
 *		2018-01-11 (1.2.0)
 *			- Updated slideshow code to use new dot layout.
 *			- Removed $.reduce().
 *			- Fixed issue with returning to the same slide via navigation arrows.
 *
 *		2020-08-25 (1.2.1)
 *			- Added Support for "Hotel Offer" header link.
 *
 *      2022-01-27 (1.2.2) (zsahs)
 *			-Added click event handlers for left and right arrows displayed on hotel room pictures to scroll through pictures.
 *
 *      2022-02-02 (1.2.3) (zsahs)
 *			-Code clean up and final adjustments to left and right arrow event handlers for scrolling through hotel images.
 *
 *		2024-05-14 (1.2.4) (jhoward)
 *			- Improve related events embed postMessage logic in main.js.
 *			- Refactor "ajax link callbacks" to <show-overlay-dialog> from main.js.
 *			- Refactor external link detection in main.js to be easier to maintain.
 *
 *		2024-07-17 (1.2.5) (jhoward)
 *			- Update window.pepTracking in main.js to sync with PeppermillReno.com version.
 *
 *		2024-12-03 (1.2.6) (jhoward)
 *			- Set recalcPageLinks() on the window object for global access in main.js.
 */


window.pepWindowLoad	= false;
jQuery(window).on("load", function () { window.pepWindowLoad = true; });

(function () {

	window.pepSlideshow	=	{

		//ELEMENTS
		$ele			:	$(),
		slides			:	$(),
		dots			:	$(),
		dotOverlays		:	$(),
		captions		:	$(),

		//TIMERS
		//slideTimer		:	null,
		transitionTimer	:	null,
		dotTimer		:	null,
		dotResetTimer	:	null,
		renderTimer		:	null,
		startTimer		:	null,
		videoTimer		:	null,
		videoStartTimer	:	null,

		//SETTINGS
		index					:	0,
		windowIsActive			:	true,
		slideshowIsActive		:	false,
		throttleTimeout			:	250,
		currentSlide			:	0,
		slideshowWidth			:	0,
		slideshowHeight			:	0,
		slideshowOffsetTop		:	0,
		lastSlideStartTime		:	0,
		transitionDuration		:	925,
		dotResetDuration		:	125,
		transitionInProgress	:	false,
		slidesShown				:	0,
		supportTransitions		:	true,
		supportTouch			:	false,
		videoStartTimeout		:	1000,
		dotDashOffset			:	76,

		//FUNCTIONS
		getSlide			:	function (index) {

			return this.slides.eq(index);

		},
		getCaption			:	function (index) {

			return this.captions.filter(function () { return parseInt($(this).data('index'), 10) === index; });

		},
		getDot				:	function (index) {

			return this.dots.filter(function () { return parseInt($(this).data('index'), 10) === index; });

		},
		getNextSlideIndex	:	function (direction) {

			if (typeof direction !== 'number')	var direction	=	1;

			var newIndex	=	this.currentSlide + direction;

			if (direction < 0 && newIndex < 0) {

				newIndex	=	this.slides.length - 1;

			} else if (direction > 0 && newIndex > this.slides.length - 1) {

				newIndex	=	0;

			}
			//console.log('getNextSlideIndex', newIndex);
			return newIndex;

		},
		calcVideoDims		:	function (videoData) {

			var newHeight		=	(videoData.sizing === 'contain')
				?	this.slideshowHeight
				:	this.slideshowWidth * videoData.height / videoData.width,
				newTop			=	(videoData.sizing === 'contain')
					?	0
					:	(newHeight - this.slideshowHeight) * -1 * videoData.focalY / 100,
				newLeft			=	0;

			if (newHeight + newTop < this.slideshowHeight) {

				newTop		=	0;
				newHeight	=	this.slideshowHeight;
				this.slideshowWidth	=	videoData.width * newHeight / videoData.height;
				newLeft		=	(this.slideshowWidth - allSlideshows[0].$ele.outerWidth()) * -1 * videoData.focalX / 100;

			}

			return {
				width	:	this.slideshowWidth,
				height	:	newHeight,
				left	:	newLeft,
				top		:	newTop
			};

		},
		checkIfActive		:	function () {
			//determine if this slideshow is active
			this.slideshowIsActive	=	!this.$ele.is(':hidden');

			return this.slideshowIsActive;

		},
		renderSlideshow		:	function () {

			var slideshowOBJ	=	this;
			var wasActive		=	this.slideshowIsActive;
			var isActive		=	this.checkIfActive();
			var $currentSlide	=	null;

			this.slideshowWidth		=	this.$ele.outerWidth();
			this.slideshowHeight	=	this.$ele.outerHeight();
			this.slideshowOffsetTop	=	this.$ele.offset().top;

			if (this.$ele.data('transform-y'))	this.slideshowOffsetTop	-=	this.$ele.data('transform-y');

			$.each(this.slides.filter('.video'), function () {

				var slideData	=	$(this).data();

				if (typeof slideData.videoPlayer === 'object') {

					$(this)
						.find('.video-player')
						.css(slideshowOBJ.calcVideoDims(slideData.videoData));

				}

			});

			if (!isActive) {

				//let's see if any other slideshows are active, otherwise indicate to the page that there aren't any
				var foundActiveSlideshow	=	false;

				for (var i = 0, l = allSlideshows.length; i < l; i++) {

					if (true === allSlideshows[i].slideshowIsActive) {

						foundActiveSlideshow	=	true;
						break;

					}

				}

				if (true === foundActiveSlideshow) {

					$container
						.removeClass('no-artwork');

				} else {

					$container
						.addClass('no-artwork');

				}

			} else if (wasActive && !isActive) {

				//pause the show since it's not active but it was
				$.each(this.slides.filter('.video'), function () {

					//pause videos
					if ($(this).data('playing') && typeof $(this).data('videoPlayer') === 'object') {

						$(this)
							.data('videoPlayer')
							.pause();

					}

					//stop slides from changing
					clearTimeout(slideshowOBJ.showTimer);

				});

			} else if (!wasActive && isActive) {

				this.changeSlide(this.currentSlide);

				//we know that this slideshow is displaying, so at least one is
				$container
					.removeClass('no-artwork');

			}

		},
		startSlideshow		:	function () {

			var nextSlide		=	0;
			var $slide			=	null;
			var slideCMSData	=	{};
			var slideshowOBJ	=	this;

			if (!this.checkIfActive())	return;

			clearTimeout(this.startTimer);

			this.changeSlide(this.currentSlide);

			//verify the dot thumbs are loaded if not on touch device
			if (!this.supportTouch) {

				$.each(this.dots, function () {

					var $dotOverlay	=	$(this).children('.dot-overlay');

					if ($dotOverlay.length && !$dotOverlay.children('img').length) {

						$dotOverlay
							.html('<img alt="' + $dotOverlay.data('thumb-alt') + '" src="' + $dotOverlay.data('thumb-src') + '" />')

					}

				});

			}


			/*$slide			=	this.getSlide(this.currentSlide);
            slideCMSData	=	$slide.data('cms-data');

            nextSlide		=	this.currentSlide + 1;*/

		},
		setupSlideshow		:	function ($slideshowContainer, slideshowIndex) {

			var slideshowOBJ	=	this;


			this.index			=	slideshowIndex;
			this.$ele			=	$slideshowContainer;
			this.slides			=	this.$ele.children('.content');
			this.dots			=	this.$ele.children('.thumb-dots').children('.dot');
			this.dotOverlays	=	this.$ele.children('.thumb-dots').children('.dot-overlay');
			this.captions		=	this.$ele.children('.slide-caps').children('.caption');

			this.supportTransitions	=	Modernizr.csstransitions;
			this.supportTouch		=	Modernizr.touchevents;

			if ($('#container').hasClass('content-page') || $('#container').hasClass('hotel-tower-page')) {

				this.$ele
					.addClass('position-static');

			}
			//check to make sure the show shouldn't be running in 10 seconds
			$(function () {

				slideshowOBJ.startTimer	=	setTimeout(function () {

					slideshowOBJ.startSlideshow();

				}, 10000);

			});

			$(window)
				.on('resize.artwork' + this.index, function () {

					clearTimeout(slideshowOBJ.renderTimer);
					slideshowOBJ.renderTimer	= setTimeout(function () {

						slideshowOBJ.renderSlideshow();

					}, slideshowOBJ.throttleTimeout);

				})
				.on('load.artwork' + this.index, function () {

					clearTimeout(slideshowOBJ.renderTimer);
					slideshowOBJ.renderTimer	= setTimeout(function () {

						slideshowOBJ.renderSlideshow();

					}, slideshowOBJ.throttleTimeout);

					slideshowOBJ
						.$ele
						.addClass('loaded');

					if (slideshowOBJ.checkIfActive()) {

						slideshowOBJ.startSlideshow();

					}

				})
				.on('blur.artwork' + this.index, function () {

					slideshowOBJ.windowIsActive	=	false;

					var $currentSlide	=	slideshowOBJ.getSlide(slideshowOBJ.currentSlide);

					if ($currentSlide.hasClass('video') && typeof $currentSlide.data('videoPlayer') === 'object') {

						$currentSlide
							.data('videoPlayer')
							.pause();

					}

				})
				.on('focus.artwork' + this.index, function (event) {

					slideshowOBJ.windowIsActive	=	true;

					var $currentSlide	=	slideshowOBJ.getSlide(slideshowOBJ.currentSlide);

					if ($currentSlide.hasClass('video') && $currentSlide.data('playing') && typeof $currentSlide.data('videoPlayer') === 'object') {
						//console.log('focus play');
						$currentSlide
							.data('videoPlayer')
							.play();

					}

				});

			this.$ele
				.children('.mobile-nav-arrow')
				.filter('.left')
				.on('click', function (event) {

					event.stopPropagation();
					event.preventDefault();

					slideshowOBJ.changeSlide(slideshowOBJ.getNextSlideIndex(-1));

				})
				.end()
				.filter('.right')
				.on('click', function (event) {

					event.stopPropagation();
					event.preventDefault();

					slideshowOBJ.changeSlide(slideshowOBJ.getNextSlideIndex(1));

				});

			this.dots
				.on('click', function (event) {

					event.preventDefault();
					event.stopPropagation();

					$(this)
						.trigger('mouseleave');

					slideshowOBJ.changeSlide(parseInt($(this).data('index'), 10));

				}).on('mouseleave', function () {

				if (!Modernizr.touchevents) {

					slideshowOBJ.dotTimer	=	setTimeout(function () {

						slideshowOBJ.dots
							.removeClass('hover');

					}, 75);

				}

			}).on('mouseenter', function () {

				clearTimeout(slideshowOBJ.dotTimer);

				if (!Modernizr.touchevents) {

					//hide all dot overlays, select the one associated with this dot, set the position for the selected overlay, then fade it into view
					slideshowOBJ.dots
						.eq($(this).data('index'))
						.addClass('hover')
						.siblings()
						.removeClass('hover');

				}

			}).each(function () {
				var duration = slideshowOBJ.slides.eq($(this).data('index')).data('cmsData').duration || 5;
				this.style.setProperty('--dot-animation-duration', '' + (duration * 1000) + 'ms');
			});



			//setup art dot
			this.dotOverlays
				.on('click', function (event) {

					$(this)
						.trigger('mouseleave')
						.prev()
						.trigger('click');

				}).on('mouseleave', function () {

				slideshowOBJ.dotTimer	= setTimeout(function () {

					slideshowOBJ.showOverlays
						.removeClass('active');

				}, 66);

			}).on('mouseenter', function () {

				clearTimeout(slideshowOBJ.dotTimer);

			});


			this.captions
				.find('.scroll-to-content')
				.on('click', function (event) {

					event.preventDefault();
					event.stopPropagation();

					var headerHeight	=	(responsive.current === 'ui-mobile')
						?	maxHeaderHeight.mobile
						:	maxHeaderHeight.desktop;
					var scrollTo		=	slideshowOBJ.$ele.offset().top + slideshowOBJ.$ele.outerHeight() - headerHeight;

					$('html, body')
						.animate({ scrollTop : scrollTo }, 750, 'easeInOutCubic');

				});


			//preload the first image of the slideshow
			this.loadSlideImage(0);


		},
		loadSlideImage	:	function (index) {

			var $slide	=	this.getSlide(index);

			if (!$slide.hasClass('video')) {

				$slide
					.css({
						backgroundImage	:	"url('" + $slide.data('cms-data').imgSrc + "')"
					});

			} else {

				$slide
					.css({
						backgroundImage	:	"url('" + $slide.children('.video-player').data('poster') + "')"
					});

			}

		},
		initVideo		:	function (index) {

			var slideshowOBJ	=	this;
			var $video			=	this.getSlide(index).filter('.video');
			var $caption		=	null;
			var $dot			=	null;
			//console.group('initVideo');
			//console.log($video.hasClass('initialized'), typeof $video.data('videoPlayer') === 'object');
			if ($video.hasClass('initialized') && typeof $video.data('videoPlayer') === 'object') {

				//if already initialized
				$video
					.data('videoPlayer')
					.setCurrentTime(0);

				if (0 === parseInt($video.data('play-count', 0), 10)) {
					//console.log('init replay');
					$video
						.data('videoPlayer')
						.play();
				}

			} else {

				//initialize a video slide
				var	videoData	=	$video.data('video-data');
				var videoBackup	=	$video.data('videoBackup')	||	$video.html();
				//console.log('play count', $video.data('play-count'), !$video.data('play-count'));
				if (!$video.data('play-count')) {
					$video.data('play-count', 0);
				}
				//console.log('play count', $video.data('play-count'));

				$caption	=	this.getCaption(index);
				$dot		=	this.getDot(index);

				$caption
					.addClass('active');

				$video
					.data({
						playing					:	false,
						videoBackup				:	videoBackup,
						videoPlayer				:	new Vimeo.Player('artwork-' + this.index + '-video-' + videoData.videoID + '-' + $video.data('index'), {
							id			:	videoData.videoID,
							//background	:	true,
							loop		:	false,	//this is handled in code, if left to `true` the `ended` event will not fire
							//autoplay: false,
							controls: false,
							muted: true
						}),
						videoData				:	videoData,
						lastReportedResolution	:	''
					})
					.on('reportResolution', function (event, player) {

						//TODO: need to determine how to check current resolution for the Vimeo player

						/*
                        try {

                            var resolution	=	player.tech_.hls.masterPlaylistController_.mainSegmentLoader_.playlist_.attributes.RESOLUTION.width + 'x' + player.tech_.hls.masterPlaylistController_.mainSegmentLoader_.playlist_.attributes.RESOLUTION.height + 'px';
                            //var vimeoID		=	$(this).data('videoData').videoID;

                            if (resolution && $(this).data('lastReportedResolution') !== resolution) {

                                pepTracking.event('Video', 'Resolution', resolution);

                                $(this)
                                    .data('lastReportedResolution', resolution);

                            }

                        } catch (e) {}
                        */
					})
					.find('.video-player')
					.css(this.calcVideoDims(videoData));

				//setup video control button interaction

				$caption
					.find('.video-btn, .volume-btn')
					.filter('.play-btn')
					.off('click.artwork')
					.on('click.artwork', function (event) {

						event.preventDefault();
						event.stopPropagation();

						$(this)
							.addClass('hide')
							.siblings('.pause-btn')
							.removeClass('hide');

						$video
							.data('playing', true);

						if ($video.hasClass('video') && typeof $video.data('videoPlayer') === 'object') {

							clearTimeout($caption.data('loader-timer'));

							$caption
								.addClass('video-playing video-played video-play-manual')
								.removeClass('video-paused video-pause-manual')
								.data('loader-timer', setTimeout(function () {

									//if ($(event.target).hasClass('vjs-error'))	return;

									$caption
										.children('.video-loader')
										.removeClass('hide');

								}, 5000));
							//console.log('click play');
							$video
								.data('videoPlayer')
								.play();

						}

					})
					.end()
					.filter('.pause-btn')
					.off('click.artwork')
					.on('click.artwork', function (event) {

						event.preventDefault();
						event.stopPropagation();

						$(this)
							.addClass('hide')
							.siblings('.play-btn')
							.removeClass('hide');

						$video
							.data('playing', false);

						if ($video.hasClass('video') && typeof $video.data('videoPlayer') === 'object') {

							$video
								.data('videoPlayer')
								.pause();

						}

						$caption
							.removeClass('video-playing video-play-manual')
							.addClass('video-paused video-pause-manual');

					})
					.end()
					.filter('.volume-btn')
					.removeClass('audio-on')
					.off('click.artwork')
					.on('click.artwork', function (event) {

						event.preventDefault();
						event.stopPropagation();

						if ($(this).hasClass('audio-on')) {

							$video
								.data('videoPlayer')
								.setVolume(0);

							$(this)
								.removeClass('audio-on');

						} else {

							$video
								.data('videoPlayer')
								.setVolume(1);

							$(this)
								.addClass('audio-on');

						}

					});

				//setup Vimeo Player event handlers
				$video
					.data('videoPlayer')
					.on('ended', function () {

						//console.log('video ended');
						$video.data('play-count', parseInt($video.data('play-count'), 10) + 1);
						$video.data('playing', false);

						if (typeof videoData.videoID !== 'undefined') {

							var videoID	=	'' + videoData.videoID;

							pepTracking.event('Video', 'Ended', videoID);

						}

						$caption
							.removeClass('video-playing')
							.addClass('video-paused video-must-manually-start');
						//console.log('num of slides', slideshowOBJ.slides.length);
						if (slideshowOBJ.slides.length > 1) {

							slideshowOBJ.changeSlide(slideshowOBJ.getNextSlideIndex(1));

						} else {

							//this video is the only slide, show a "reply" button

							//replay
							$video
								.data('videoPlayer')
								.setCurrentTime(0)
							/*.then(function () {

                                $video
                                    .data('videoPlayer')
                                        .play();

                            })*/;


						}

					});



				//setup video event handlers
				$video
					.data('videoPlayer')
					.on('pause', function () {
						//console.log('video paused');
						//$video
						//	.data('playing', false);

						$caption
							.removeClass('video-playing video-play-manual')
							.addClass('video-paused')
							.find('.play-btn, .replay-btn')
							.removeClass('hide')
							.end()
							.find('.pause-btn')
							.addClass('hide');

						$video
							.data('videoPlayer')
							.getCurrentTime()
							.then(function (time) {
								if (time < 0.1) {
									$caption
										.addClass('video-must-manually-start');
								}
							});

						clearTimeout($caption.data('loader-timer'));

						//$caption
						//	.children('.video-loader')
						//		.addClass('hide');

						//clearTimeout(slideshowOBJ.showTimer);

					});

				$video
					.data('videoPlayer')
					.on('play', function (a, b, c) {
						//console.log('video play');
						if (!$video.data('play-tracked')) {

							pepTracking.event('Video', 'Started', videoData.videoID.toString());

						}

						$video
							.data('playing', true)
							.data('play-tracked', true);

						$caption
							.removeClass('video-paused video-pause-manual')
							.addClass('video-playing video-played')
							.find('.play-btn, .replay-btn')
							.addClass('hide')
							.end()
							.find('.pause-btn')
							.removeClass('hide');

						clearTimeout($caption.data('loader-timer'));

						$caption
							.children('.video-loader')
							.addClass('hide');

						clearTimeout(slideshowOBJ.showTimer);

					});

				$video
					.data('videoPlayer')
					.on('error', function (data) {

						//TODO: need to figure out how to detect if video is not supported

						//check if the video format is supported
						/*if (parseInt($video.data('videojs').error().code) === 4) {

                            //if not then hide video controls, act like nothing is wrong :)
                            $video
                                .closest('.artwork')
                                    .addClass('video-not-supported');

                        }*/

						pepTracking.event('Video', 'Error', data.name);

					});

				//TODO: only show loading spinner if the play button was pressed ???
				/*$video
                    .data('videojs')
                        .on('loadstart', function (event) {

                            $caption
                                .data('loader-timer', setTimeout(function () {

                                    if (Modernizr.touchevents || $(event.target).hasClass('vjs-error'))	return;

                                    $artCaption
                                        .eq(index)
                                            .find('.video-loader')
                                                .removeClass('hide');

                                }, 5000));

                        });*/

				$video
					.data('videoPlayer')
					.on('play', function () {

						clearTimeout($caption.data('loader-timer'));

						$caption
							.children('.video-loader')
							.addClass('hide');

					});

				if ($dot.length) {

					$video
						.data({
							lastRenderDotOffset	:	-1,
							lastRenderDotText	:	-1
						})
						.data('videoPlayer')
						.on('timeupdate', function (data) {

							if (typeof data !== 'object')	return;

							$video
								.trigger('reportResolution', [this]);

							if ($video.hasClass('active')) {

								//update countdown text and the countdown animation

								if ($video.data('lastRenderDotOffset') !== dashOffset || $video.data('lastRenderDotText') !== countText) {

									var dashOffset	=	parseInt(slideshowOBJ.dotDashOffset * data.percent, 10);
									var countText	=	parseInt(data.duration - data.seconds, 10);

									$video
										.data({
											lastRenderDotOffset	:	dashOffset,
											lastRenderDotText	:	countText
										});

									slideshowOBJ.dots
										.filter('[data-index=' + $video.data('index') + ']')
										.find('.text')
										.text(countText)
										.end()
										.find('circle')
										.css({
											'stroke-dashoffset'	:	dashOffset + 'px'
										});

								}

							}

						});

				} else {

					//we still want to report video resolutions even if there are no dots
					$video
						.data('videoPlayer')
						.on('timeupdate', function (data) {

							if (typeof data !== 'object')	return;

							$video
								.trigger('reportResolution', [this]);

						});

				}

				if (parseInt($video.data('audio'), 10) === 0) {

					$video
						.data('videoPlayer')
						.setVolume(0);

				}

				$video
					.addClass('initialized');


				if (typeof $video.data('videoPlayer') === 'object') {

					/*$video
                        .children('.video-js')
                            .css({
                                backgroundImage	:	"url('/library/api/video-poster.php?VIDEO_ID=" + videoData.videoID + "')"
                            });*/
					//console.log('init');
					$video
						.data('videoPlayer')
						.ready()
						.then(function () {

							var autoplay	=	parseInt($video.data('video-data').autoplay, 10);
							//console.log('autoplay', autoplay);
							if (autoplay === 1) {// && Modernizr.videoautoplay

								clearTimeout(slideshowOBJ.videoStartTimer);
								//console.log('videoStartTimeout', slideshowOBJ.videoStartTimeout);
								//give the browser a moment to catch up before playing
								slideshowOBJ.videoStartTimer	=	setTimeout(function () {

									if (0 === parseInt($video.data('play-count'), 10) && $video.hasClass('active') && slideshowOBJ.windowIsActive === true) {
										//console.log('ready play');
										$video
											.data('videoPlayer')
											.play()
											.catch(function (data) {

												//an error occurred...
												console.log(data);

											});

									}

								}, slideshowOBJ.videoStartTimeout);

							}

						});

					$video
						.find('.video-player')
						.addClass('active');

				}

			}
			//console.groupEnd();
		},
		changeSlide		:	function (newIndex) {
			//console.log('changeSlide');
			var oldSlideIndex	=	this.slides.filter('.active').data('index');
			var slideshowOBJ	=	this;

			this.lastSlideStartTime	=	new Date().getTime();

			if (this.getSlide(newIndex).hasClass('video')) {
				//console.log('is video slide');
				this.initVideo(newIndex);

			}

			//only run when there is more than one slide
			if (this.slides.length < 2)	return false;

			//only run when an existing slide is requested
			if (this.slides.eq(newIndex).length === 0)	return false;

			//all transitions must finish before new ones can start
			if (this.transitionInProgress)	return false;

			clearTimeout(this.showTimer);
			clearTimeout(this.videoStartTimer);

			this.activateSlide(newIndex);

			if (newIndex !== this.currentSlide) {

				//tasks to run only if we're showing a new slide

				this.deactivateSlide(oldSlideIndex);

				if (newIndex >= this.slides.length.length || newIndex < 0) {

					newIndex	=	0;

				}

				this.currentSlide	=	newIndex;

			}

			if (!this.slides.filter('.active').hasClass('video')) {
				this.showTimer	=	setTimeout(function () {

					slideshowOBJ.changeSlide(slideshowOBJ.getNextSlideIndex(1));

				}, parseInt(this.slides.filter('.active').data('cms-data').duration, 10) * 1000 + this.transitionDuration);

			}

		},
		positionThumbs		:	function (index) {

			//if this slide has a caption
			if (this.getSlide(index).hasClass('has-cap')) {

				//place thumbs above the caption for mobile ui
				this.$ele
					.children('.thumb-dots')
					.addClass('has-cap');

			} else {

				this.$ele
					.children('.thumb-dots')
					.removeClass('has-cap');

			}

		},
		pauseCurrentVideo	:	function () {

			var $activeVideoSlide	=	this.slides.filter('.active').filter('.video');

			//pause a video if it's playing in mobile ui
			if ($activeVideoSlide.length && typeof $activeVideoSlide.data('videoPlayer') === 'object') {

				$activeVideoSlide
					.data('videoPlayer')
					.pause();

			}

		},
		playCurrentVideo	:	function () {

			var $activeVideoSlide	=	this.slides.filter('.active').filter('.video');

			//play a video if it's paused
			if ($activeVideoSlide.length && $activeVideoSlide.data('playing') && typeof $activeVideoSlide.data('videoPlayer') === 'object') {
				//console.log('playCurrentVideo play');
				$activeVideoSlide
					.data('videoPlayer')
					.play();

			}

		},
		startSlideDot		:	function (slideIndex) {

			var $slide			=	this.getSlide(slideIndex);
			var $dot			=	this.dots.eq(slideIndex);
			var slideshowOBJ	=	this;

			//video dot animations are handled via video code
			if (this.slides.length < 2)	return;

			if ($slide.hasClass('video')) {

				//just activate video dots
				$dot
					.addClass('active');

			} else {

				$dot
					.addClass('reset')
					.children('.text')
					.text('');

				var dotDuration				=	parseInt($slide.data('cms-data').duration, 10),
					dotStartTime			=	new Date().getTime(),
					dotTransitionDuration	=	(2 > this.slidesShown)	?	-250	:	(750 - this.dotResetDuration),
					dotLastRender			=	-1,
					dotRunAni				=	function () {

						var dotTimeLeft		=	dotDuration - Math.floor((new Date().getTime() - dotStartTime - dotTransitionDuration) / 1000);

						if (dotTimeLeft !== dotLastRender) {

							dotLastRender	=	dotTimeLeft;

							if (dotTimeLeft < 0) {

								//timer done
								slideshowOBJ.stopSlideDot(slideIndex);

								dotTimeLeft		=	null;
								dotDuration		=	null;
								dotStartTime	=	null;
								dotLastRender	=	null;
								slideIndex		=	null;
								$slide			=	null;
								$dot			=	null;

							} else if ($dot.data('animation-timer-running')) {

								$dot
									.removeClass('reset')
									.children('.text')
									.text(dotTimeLeft);

								//timer not done
								requestAnimationFrame(dotRunAni);

							}

						} else {

							//not a full second has gone by
							requestAnimationFrame(dotRunAni);

						}

					};

				clearTimeout(this.dotResetTimer);

				this.dotResetTimer	=	setTimeout(function () {

					$dot
						.data('animation-timer-running', true);

					dotRunAni();

				}, this.dotResetDuration);

				//first slide on page load has no transition so no need to wait for the transition to end before starting the countdown
				//if (isFirstSlideOnPageLoad)	requestAnimationFrame(dotRunAni);

				$dot
					/*.onCSSTransitionEnd(function () {

                        if (!isFirstSlideOnPageLoad)	requestAnimationFrame(dotRunAni);

                    })*/
					.addClass('active')
					.find('.text')
					.text(dotDuration);

			}

		},
		stopSlideDot	:	function (slideIndex) {

			var $dot	=	this.dots.eq(slideIndex);

			$dot
				.data('animation-timer-running', false);

			$dot
				/*.children('.text')
                    .onCSSTransitionEnd(function () {

                        $(this)
                            .text('');

                    })
                .end()*/
				.find('circle')
				.css({
					strokeDashoffset	:	''
				})
				.end()
				.removeClass('active');


		},
		activateSlide	:	function (index) {

			var $slide			=	this.getSlide(index);
			var slideshowOBJ	=	this;

			this.lastSlideStartTime	=	new Date().getTime();
			this.slidesShown++;

			this.transitionInProgress	=	true;

			this.transitionTimer	=	setTimeout(function () {

				slideshowOBJ.transitionInProgress	=	false;

			}, this.transitionDuration);

			//activate new slide
			this.loadSlideImage(index);

			$slide
				.addClass('active');

			//activate new caption
			this.captions
				.filter('[data-index=' + index + ']')
				.addClass('active');

			//activate new dot
			this.startSlideDot(index);

			//position thumbs
			this.positionThumbs(index);

			//initialize video if necessary
			if ($slide.hasClass('video') && !$slide.hasClass('initialized')) {

				this.initVideo(index, true);

			}/* else {

					//NOTE: this is now handled in changeSlide()

					//setup timer for next slide
					clearTimeout(this.slideTimer);

					this.slideTimer	= setTimeout(function () {
						console.log('timer', 'slideTimer');
						slideshowOBJ.changeSlide(index);

					}, $slide.data('cms-data').duration * 1000);

				}*/

		},
		deactivateSlide	:	function (index) {

			var $slide		=	this.getSlide(index);
			var $caption	=	this.getCaption(index);

			if ($slide.hasClass('video')) {

				this.dots
					.filter('[data-index=' + index + ']')
					.find('.dot-circle')
					.children()
					.css({
						transitionDuration	:	'',
						transform			:	''
					});

				if (typeof $slide.data('videoPlayer') === 'object') {

					this.videoTimer	=	setTimeout(function () {

						$slide
							.removeClass('initialized')
							.data('videoPlayer')
							.destroy();

						$slide
							.removeData('videoPlayer');

						$caption
							.removeClass('video-playing video-played video-paused');

						if (typeof $slide.data('video-backup') === 'string') {

							$slide
								.append($slide.data('video-backup'));

						}

					}, 1000);

				}

			}

			//deactivate content
			$slide
				.removeClass('active');

			//deactivate caption
			$caption
				.removeClass('active');

			//update transition duration for dot

			this.stopSlideDot(index);

		}
	};
	var pauseCurrentVideo	=	function () {

			//pause a video if it's playing in mobile ui
			if ($('html').hasClass('ui-mobile')) {

				for (var i = 0, l = allSlideshows.length; i < l; i++) {

					if (allSlideshows[i].slideshowIsActive && typeof allSlideshows[i].slides.filter('.active.video').data('videoPlayer') === 'object') {

						allSlideshows[i].slides
							.filter('.active.video')
							.data('videoPlayer')
							.pause();

					}

				}

			}

		},
		playCurrentVideo	=	function () {

			//play a video if it's paused

			for (var i = 0, l = allSlideshows.length; i < l; i++) {

				if (allSlideshows[i].slideshowIsActive && typeof allSlideshows[i].slides.filter('.active.video').data('videoPlayer') === 'object') {
					//console.log('playCurrentVideo (2?) play');
					allSlideshows[i].slides
						.filter('.active.video')
						.data('videoPlayer')
						.play();

				}

			}

		};

	window.allSlideshows	=	[];

	$(function () {

		$.each($('.artwork'), function (i) {

			var slideshow	=	$.extend(true, {}, pepSlideshow);

			slideshow.setupSlideshow($(this), i);

			allSlideshows.push(slideshow);

		});

	});












	//globals
	var $container		= $('#container'),
		$header			= $('#header'),
		$footer			= $('#footer'),
		dims			= {
			window	: {
				w		: $(window).width(),
				h		: $(window).height(),
				timer	: null
			}
		},
		cookieData		=	$('html').data('cookie'),
		responsive		= {
			current			:	'ui-desktop',
			isOldIE			:	false,
			queries			:	[
				'only screen and (max-width: 800px)',
				'only screen and (min-width: 801px) and (max-width: 1024px)',
				'only screen and (min-width: 1025px) and (max-width: 1480px)',
				'only screen and (min-width: 1481px)'
			],
			mediaElements	:	[
				'#ui-check-mobile',
				'#ui-check-tablet',
				'#ui-check-desktop',
				'#ui-check-widescreen'
			],
			classes			:	[
				'ui-mobile',
				'ui-tablet',
				'ui-desktop',
				'ui-widescreen'
			],
			orientation		:	'landscape',
			timer			:	null,
			getCurrentUI	:	function () {

				if ('matchMedia' in window) {

					for (var i = 0, l = responsive.queries.length; i < l; i++) {

						if (window.matchMedia(responsive.queries[i]).matches && typeof responsive.classes[i] === 'string') {

							return responsive.classes[i];

						}

					}

				} else {

					for (var i = 0, l = responsive.mediaElements.length; i < l; i++) {

						if ($(responsive.mediaElements[i]).is(':visible') && typeof responsive.classes[i] === 'string') {

							return responsive.classes[i];

						}

					}

				}

			},
			allowUITransition	:	function () {

				$('html')
					.addClass('ui-transition');

				clearTimeout(responsive.timer);

				responsive.timer	=	setTimeout(function () {

					$('html')
						.removeClass('ui-transition');

					currentScroll	= $(window).scrollTop();

				}, 250);

			},
			setOrientation	:	function () {

				if (dims.window.w > dims.window.h) {

					$("html").addClass("landscape").removeClass("portrait");
					responsive.orientation	= 'landscape';

				} else {

					$("html").addClass("portrait").removeClass("landscape");
					responsive.orientation	= 'portrait';

				}

			},
			getCookie		:	function () {

				return document.cookie.replace(/(?:(?:^|.*;\s*)pepui\s*\=\s*([^;]*).*$)|^.*$/, "$1");

			},
			getClass		:	function () {

				return document.getElementsByTagName('html')[0].className.replace(/(?:(?:^|.*;\s*)pepui\s*\=\s*([^;]*).*$)|^.*$/, "$1");

			},
			setClass		:	function (newUI) {

				$('html').removeClass(responsive.classes.join(' ')).addClass(newUI);

			},
			setCookie		:	function (newUI) {

				if (responsive.current !== newUI) {

					document.cookie = 'pepui=' + newUI + '; path=' + cookieData.b + cookieData.s + '; ' + cookieData.h;

				}

			},
			update			:	function () {

				//determine which responsive-design-break-point should be used
				var newUI	=	responsive.getCurrentUI();

				//determine orientation
				responsive.setOrientation();

				//set the cookie for subsequent requests (if needed)
				responsive.setCookie(newUI);

				//set the class
				responsive.setClass(newUI);

				//save current UI
				responsive.current	= newUI;

				//make sure transitions between UIs are smooth
				responsive.allowUITransition();

			},
			init			:	function () {

				//find the current UI
				//first look for a cookie
				var cookieValue	=	responsive.getCookie(),
					classValue	=	responsive.getClass();

				if		(cookieValue)	responsive.current	=	cookieValue;
				else if	(classValue)	responsive.current	=	classValue;

				responsive.checkOldIE();

				responsive.update();

			},
			checkOldIE		:	function () {

				var rv = -1;

				if (navigator.appName == 'Microsoft Internet Explorer') {
					var ua = navigator.userAgent;
					var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
					if (re.exec(ua) != null)
					rv = parseFloat( RegExp.$1 );
				}

				if (rv > -1 && rv < 9) {

					responsive.isOldIE	=	true;

					$('html')
						.addClass('old-ie');

				}

			}
		},
		isAndroidDevice				= (navigator.userAgent.toLowerCase().indexOf("android") > -1),
		isMinified					=	!/event/.test(function (event) {});

	if (cookieData && cookieData.s === 'secure')	cookieData.s	=	'; secure';

	responsive.init();

	//setup console if it doesn't exist to not cause errors
	if (typeof console !== "object") console = { log : function () {} };




















	//MAIN NAVIGATION CODE//
	var nav			= {
			element		:	$('#nav'),
			timer		:	null,
			timer2		:	null,
			clickEvent	:	'click',
			links		:	$('#nav').find('.nav-link')
		};

	function setupEmailReplacements() {

		$('[data-email-replacement]')
			.filter(function () {

				return $(this).data('setup') !== true;

			})
			.each(function () {

				var data	=	$(this).data();

				if ($(this).is('a')) {

					this.href	=	'mailto: ' + data.user + '@' + data.domain + '.' + data.extension;

				} else {

					$(this).text(data.user + '@' + data.domain + '.' + data.extension);

				}

			});

	}

	setupEmailReplacements();

	nav.element
		.find('.menu-handle')
			.on('click', function (event) {

				event.preventDefault();
				event.stopPropagation();

				$('html')
					.toggleClass('show-nav');

				if ($('html').hasClass('show-nav')) {

					pauseCurrentVideo();

					$(this)
						.data('lastFocusedElement', document.activeElement);

					nav.element.find('.links')
						.focus();

				} else {

					playCurrentVideo();

					if (typeof $(this).data('lastFocusedElement') === 'object')	$(this).data('lastFocusedElement').focus();

				}

			});

	/*$footer
		.find('.menu-handle')
			.on('click', function (event) {

				event.preventDefault();
				event.stopPropagation();

				var $handle	=	$(this);

				$('html').toggleClass('show-nav');

			});*/

	nav.links
		.on('click', function (event) {

			event.stopPropagation();

		});

	$(document)
		.on('click', function () {

			$('html').removeClass('show-nav');

		});









	//page link scroll animation
	var $pageLinks			=	$('.page-links')
									.find('.item'),
		pageLinkResizetimer	=	null,
		pageLinkObserver;

	window.resetPageLinks	=	function ($newPageLinks) {

		if	(typeof $newPageLinks === 'object')	$pageLinks	=	$newPageLinks;
		else									$pageLinks	=	$('.page-links').find('.item');

		initPageLinks();

	};

	function renderPageLinks(entries, observer) {

		var visibleCount		=	0,
			localScrollReady	=	scrollReady;

		entries.forEach(function (entry, index) {

			var $entry	=	$(entry.target);

			if (entry.intersectionRatio >= 0.1) {

				$entry.trigger('slideshow-start');

			} else {

				$entry.trigger('slideshow-stop');

			}

			if ($entry.data('scrolled'))	return;

			if (entry.intersectionRatio > 0) {

				loadPageLinkImage($entry);

			}

			if (entry.intersectionRatio > 0.24 || (!localScrollReady && entry.intersectionRatio > 0)) {

				entry.target.classList.add('scrolled', 'delay-' + visibleCount++);

				$entry.data('scrolled', true);

			}

		});

		if (!scrollReady) {

			scrollReady	=	true;

			$('html')
				.addClass('scroll-ready');

		}

	}

	function initPageLinks() {

		//for testing
		//delete IntersectionObserver;

		if (typeof IntersectionObserver === 'function') {

			var observerOptions	=	{
					root		:	null,	//defaults to viewport
					rootMargin	:	($header.length && $footer.length)	?	'-' + $header.css('height') + ' 0px -' + $footer.find('.above-the-fold').css('height') + ' 0px'	:	'0px 0px 0px 0px',
					threshold	:	[ 0, 0.1, 0.25 ]
				};

			pageLinkObserver	=	new IntersectionObserver(renderPageLinks, observerOptions);

			for (let i = 0, l = $pageLinks.length; i < l; i++) {

				if ($pageLinks.eq(i).data('slideshowCurrentIndex') == null) {

					$pageLinks
						.eq(i)
							.data({
								slideshowCurrentIndex	:	0,
								slideshowTimer			:	null,
								slideshowRunning		:	false
							});

				}

				$pageLinks
					.eq(i)
						.off('slideshow-start.pl')
						.on('slideshow-start.pl', function () {

							if ($(this).data('slideshowRunning') || $(this).find('.images').find('.img').length < 2)	return;

							$(this)
								.data('slideshowRunning', true);

							(function ($ele) {

								$ele
									.data('slideshowTimer', setInterval(function () {

										var $images		=	$ele.find('.images').find('.img'),
											nextIndex	=	($ele.data('slideshowCurrentIndex') >= $images.length - 1)
																?	0
																:	$ele.data('slideshowCurrentIndex') * 1 + 1;

										$images
											.eq($ele.data('slideshowCurrentIndex'))
												.addClass('hide')
											.end()
											.eq(nextIndex)
												.removeClass('hide');

										$ele.data('slideshowCurrentIndex', nextIndex);

									}, 6000));

							})($(this));

						})
						.off('slideshow-stop.pl')
						.on('slideshow-stop.pl', function () {

							clearInterval($(this).data('slideshowTimer'));

							$(this)
								.data('slideshowRunning', false);

						})
						.off('mouseenter.pl')
						.on('mouseenter.pl', function () {

							$(this)
								.trigger('slideshow-stop');

						})
						.off('mouseleave.pl')
						.on('mouseleave.pl', function () {

							$(this)
								.trigger('slideshow-start');
						})
						.find('.arrows .right, .arrows .left')
							.off('click.pl')
							.on('click.pl', function () {
								event.stopPropagation();
								event.preventDefault();
								let $hotelImages = $(this).closest('.images').find('.img')
								const $activeImage = $hotelImages.not('.hide');
								let nextIndex;
								if($(this).hasClass('right')) {
									nextIndex = ($activeImage.index() >= $hotelImages.length - 1)
										? 0
										: $activeImage.index() * 1 + 1;
								} else {
									nextIndex = ($activeImage.index() <= 0)
										? $hotelImages.length -1
										: $activeImage.index() * 1 - 1;
								}
								$hotelImages
									.eq($activeImage.index())
										.addClass('hide')
									.end()
									.eq(nextIndex)
										.removeClass('hide');
								});

				pageLinkObserver.observe($pageLinks[i]);

			}

		} else {

			checkPageLinks();

		}

	}

	window.recalcPageLinks = function () {

		if (typeof IntersectionObserver === 'function') {

			initPageLinks();

		} else {

			$.each($pageLinks, function (i) {

				$pageLinks
					.eq(i)
						.data({
							offsetTop	:	$pageLinks.eq(i).offset().top,
							height		:	$pageLinks.eq(i).outerHeight()
						});

			});

			checkPageLinks();

			lastRenderedScroll	=	-1;

		}

	}

	$(window)
		.on('resize.page-links load.page-links', function () {

			clearTimeout(pageLinkResizetimer);

			pageLinkResizetimer	=	setTimeout(recalcPageLinks, 100);

		});

	$(initPageLinks);














	//SUB-NAVIGATION CODE
	if ('history' in window) {

		var originalScrollPoint	=	0;

		$('.page-link-subnav')
			.find('a')
				.on('click', function (event) {

					//track this click
					pepTracking.event('Subnav', 'Click', $(this).attr('href'), 0, false);

					if ($(this).attr('href').substr(0, 1) !== '#')	return;

					event.preventDefault();

					var linkHash		=	$(this).attr('href').replace('#', '');

					if (linkHash.length === 0)	return;

					var $pageLinkGroup	=	$('#' + linkHash).filter('.page-link-group-hash');

					if ($pageLinkGroup.length) {

						$('html, body')
							.animate({ scrollTop : $pageLinkGroup.offset().top }, 500, 'easeInOutCubic');

						window.history.replaceState({
							scrollTop	:	$(window).scrollTop()
						}, $('title').text(), window.location);

						window.history.pushState({
							scrollTop	:	$(window).scrollTop()
						}, $('title').text(), '#' + linkHash);

						//focus the header for the section to maintain tabindex accessibility
						$pageLinkGroup
							.next('h2')
								.focus();

					}

				});

		$(window)
			.on('popstate', function (event) {

				var scrollTo	=	0;

				if (typeof event.originalEvent.state !== 'undefined' && event.originalEvent.state && typeof event.originalEvent.state.scrollTop !== 'undefined') {

					scrollTo	=	event.originalEvent.state.scrollTop;

				} else {

					var linkHash		=	window.location.hash.replace('#', '');

					if (linkHash.length === 0)	return;

					var $pageLinkGroup	=	$('#' + linkHash).filter('.page-link-group-hash');

					if ($pageLinkGroup.length === 0)	return;

					scrollTo	=	$pageLinkGroup.offset().top;

				}

				$('html, body')
					.animate({ scrollTop : scrollTo }, 500, 'easeInOutCubic');

				event.preventDefault();

			})

	}



















	//HEADER CODE//
	var headerShadowScrollDist	=	Math.max(Math.min($(window).height() / 2.5, 600), 250);
	var headerTopScrollDist		=	$('#header-static').height();	//TODO: need to update when UI changes
	var footerScrollDist		=	50;
	var artworkScrollRatio = {
			mobile	:	0,
			desktop	:	0.5
		};
	var minHeaderOpacity = {
			mobile	:	1,
			desktop	:	0.7
		};
	var maxHeaderOpacity = {
			mobile	:	1,
			desktop	:	1
		};
	var minFooterOpacity = {
			mobile	:	1,
			desktop	:	1//0.5
		};
	var maxFooterOpacity = {
			mobile	:	1,
			desktop	:	1
		};
	var maxHeaderTop	 = {
			mobile	:	0,
			desktop	:	3
		};
	var minHeaderTop	 = {
			mobile	:	0,
			desktop	:	0
		};
	//var navBgColorTemplate		=	'rgba(255, 255, 255, {opacity})';
	//var footerBgColorTemplate	=	'rgba(255, 255, 255, {opacity})';
	var currentScroll			=	0;
	var lastRenderedScroll		=	-1;
	var scrollReady				=	false;
	var pageLinkBuffer			=	500;

	window.loadPageLinkImage	=	function ($pageLink) {

		$pageLink
			.filter(function () {  return !$(this).data('imageLoaded'); })
				.data('imageLoaded', true)
					.find('.img')
						.each(function () {

							if (!$(this).data('img-src'))	return;

							$(this)
								.css({
									backgroundImage	:	'url(\'' + $(this).data('img-src') + '\')'
								});

						});

	}

	function checkPageLinks() {

		var scrollCount		=	0,
			windowHeight	=	$(window).height() - 48;

		$.each($pageLinks, function (i) {

			if (!$pageLinks.eq(i).data('offsetTop')) {

				$pageLinks
					.eq(i)
						.data({
							offsetTop	:	$pageLinks.eq(i).offset().top,
							height		:	$pageLinks.eq(i).outerHeight()
						});

			}

			//only if the page link is in the viewport and hasn't already been animated into position
			if (!$pageLinks.eq(i).data('scrolled') && $pageLinks.eq(i).data('offsetTop') <= currentScroll + windowHeight) {

				if ($pageLinks.eq(i).data('offsetTop') + $pageLinks.eq(i).data('height') >= currentScroll) {

					//mark as scrolled
					$pageLinks
						.eq(i)
							.addClass('scrolled delay-' + scrollCount)
							.data('scrolled', true);

					scrollCount++;

					//load image
					loadPageLinkImage($pageLinks.eq(i));

					//preload larger image source if set
					if ($pageLinks.eq(i).data('image-src'))	$("<img />")[0].src	=	$pageLinks.eq(i).data('image-src');

				} else {

					//above the current viewport and not yet shown

					//check if the image should be preloaded
					if ($pageLinks.eq(i).data('offsetTop') + $pageLinks.eq(i).data('height') >= currentScroll - pageLinkBuffer) {

						//load image
						loadPageLinkImage($pageLinks.eq(i));

					}

					$pageLinks
						.eq(i)
							.addClass('above-viewport');

				}

			} else if (!$pageLinks.eq(i).data('scrolled') && $pageLinks.eq(i).data('offsetTop') <= currentScroll + windowHeight + pageLinkBuffer) {

				//ok, not in view but close, preload the image
				//load image
				loadPageLinkImage($pageLinks.eq(i));


			}

			if (!scrollReady) {

				setTimeout(function () {

					$('html')
						.addClass('scroll-ready');

					scrollReady	=	true;

				}, scrollCount * 150);

			}

		});

	}

	function renderMainNav() {

		//only render when the scroll has changed
		if (lastRenderedScroll !== currentScroll) {

			var headerPercent		=	(currentScroll / headerShadowScrollDist > 1)
											?	1
											:	currentScroll / headerShadowScrollDist,
				footerPercent		=	(currentScroll >= footerScrollDist)
											?	((currentScroll - footerScrollDist) / headerShadowScrollDist > 1)
													?	1
													:	(currentScroll - footerScrollDist) / headerShadowScrollDist
											:	0,
				headerHeight		=	(responsive.current === 'ui-mobile')
											?	60
											:	100,
				/*headerOpacity		=	(responsive.current === 'ui-mobile' || responsive.current === 'ui-tablet')
											?	minHeaderOpacity.mobile + (maxHeaderOpacity.mobile - minHeaderOpacity.mobile) * headerPercent
											:	minHeaderOpacity.desktop + (maxHeaderOpacity.desktop - minHeaderOpacity.desktop) * headerPercent,*/
				footerOpacity		=	(responsive.current === 'ui-mobile' || responsive.current === 'ui-tablet')
											?	minFooterOpacity.mobile + (maxFooterOpacity.mobile - minFooterOpacity.mobile) * footerPercent
											:	minFooterOpacity.desktop + (maxFooterOpacity.desktop - minFooterOpacity.desktop) * footerPercent
				headerTop			=	(responsive.current === 'ui-mobile' || responsive.current === 'ui-tablet')
											?	0
											:	Math.max(maxHeaderTop.desktop * -1, minHeaderTop.desktop - (maxHeaderTop.desktop * currentScroll / headerTopScrollDist));

			$header
				/*.css({
					backgroundColor	:	navBgColorTemplate.replace('{opacity}', headerOpacity)
				})*/
				.find('.shadow')
					.css({
						opacity	:	headerPercent
					});

			if (Modernizr.csstransforms) {

				$header
					.css({
						transform	:	'translateY(' + headerTop + 'rem)'
					});

			} else {

				$header
					.css({
						top	:	headerTop + 'rem'
					});

			}

			if (currentScroll + $(window).height() - footerScrollDist >= $container.outerHeight()) {

				var distanceThrough	=	$container.outerHeight() - (currentScroll + $(window).height()) + footerScrollDist,
					percentThrough	=	Math.abs(distanceThrough / ($footer.height() - footerScrollDist));

				$footer
					.find('.above-the-fold')
						.addClass('static')
						.children('.shadow')
							.css({
								opacity	:	1 - percentThrough
							});

				$('html')
					.removeClass('footer-showing');

			} else if (currentScroll >= footerScrollDist) {

				$footer
					.find('.above-the-fold')
						.removeClass('static')
						.css({
							transform	:	'translateY(0px)',
							opacity		:	footerOpacity
						})
						.children('.shadow')
							.css({
								opacity	:	footerPercent
							});

				$('html')
					.addClass('footer-showing');

			} else {

				$footer
					.find('.above-the-fold')
						.removeClass('static')
						.css({
							transform	:	'translateY(' + (footerScrollDist - currentScroll) + 'px)',
							opacity		:	footerOpacity
						})
						.children('.shadow')
							.css({
								opacity	:	footerPercent
							});

				$('html')
					.removeClass('footer-showing');

			}

			/*if (currentScroll < $(window).height() - $header.height()) {

				var localArtworkScrollRatio	=	(Modernizr.touchevents)
													?	artworkScrollRatio.mobile
													:	artworkScrollRatio.desktop;

				$artwork
					.css({
						transform	:	'translateY(' + (localArtworkScrollRatio * currentScroll) + 'px) translateZ(0)'
					});

			}*/


			//check if any slideshows need to be paused
			$.each(allSlideshows, function (i) {
				var videoOBJ	=	(allSlideshows[i].slideshowIsActive)	?	allSlideshows[i].slides.filter('.active.video.initialized').data('videoPlayer')	:	undefined;

				//if the artwork is out of viewport, do nothing (but pause videos)
				if (allSlideshows[i].slideshowOffsetTop + allSlideshows[i].slideshowHeight - headerHeight <= currentScroll) {
					if (typeof videoOBJ === 'object') {
						videoOBJ
							.getPaused()
							.then(function (paused) {
								if (!paused) {
									videoOBJ
										.pause();
								}
							});
					}
				} else if (allSlideshows[i].slideshowIsActive) {
					//console.log('try to play');
					//console.log(typeof videoOBJ === 'object', allSlideshows[i].slides.eq(allSlideshows[i].currentSlide).data('playing'), allSlideshows[i].getCaption(allSlideshows[i].currentSlide).hasClass('video-played'), !allSlideshows[i].getCaption(allSlideshows[i].currentSlide).hasClass('video-pause-manual'));
					if (typeof videoOBJ === 'object' && allSlideshows[i].slides.eq(allSlideshows[i].currentSlide).data('playing') && allSlideshows[i].getCaption(allSlideshows[i].currentSlide).hasClass('video-played') && !allSlideshows[i].getCaption(allSlideshows[i].currentSlide).hasClass('video-pause-manual')) {
						//console.log('scroll play');
						videoOBJ
							.getPaused()
							.then(function (paused) {
								if (paused) {
									videoOBJ
										.play();
								}
							});
					}
				}
			});

			//check if any page link items need to be animated
			if (typeof IntersectionObserver === 'undefined')	checkPageLinks();

			//update last rendered scroll position
			lastRenderedScroll	= currentScroll;

		}

		requestAnimationFrame(renderMainNav)

	}

	renderMainNav();

	if ('addEventListener' in window) {

		window
			.addEventListener('scroll', function (event) {

				currentScroll	= $(window).scrollTop();

			}, {
				passive	:	true
			});

	} else {

		window
			.onscroll	=	function (event) {

				currentScroll	= $(window).scrollTop();

			};

	}


	$(function () {

		currentScroll	= $(window).scrollTop();

	});

	$(window)
		.on('resize.pagelinks load.pagelinks', function () {

			currentScroll	= $(window).scrollTop();

			if (typeof IntersectionObserver === 'undefined')	checkPageLinks();

		});









	//DIALOG CODE
	window.showLoader	=	function () {

		$('html')
			.addClass('show-overlay show-loading-spinner');

	};

	window.hideLoader	=	function () {

		$('html')
			.removeClass('show-overlay show-loading-spinner');

		$('.dialog')
			.trigger('close', [true]);

	};

	$(document)
		.on('click', function () {

			$('html')
				.removeClass('show-overlay clear-overlay show-loading-spinner');

			$('.dialog')
				.trigger('close', [true]);

		})
		.on('keydown', function (event) {

			if (event.which === 27)	$('.dialog').trigger('close');

		});

	$(document)
		.on('click', 'a.ajax-link', function (event) {
			const $link	=	$(this);

			if (typeof $link.data('query') !== 'string' && typeof $link.data('callback') !== 'string')	return;

			event.preventDefault();

			window.showOverlayDialog($link.data(), this);
		})



  require('./helpers/ExternalLinkWarning');



	$header
		.find('.search')
			.on('click', function (event) {

				event.preventDefault();
				event.stopPropagation();

				if (!$(this).hasClass('active')) {

					$(this)
						.addClass('active')
						.find('input')
							.focus()
							.select();

				} else if ($(this).find('input').val() !== '') {

					$(this)
						.find('input')
							.trigger('send');

				} else {

					$(this)
						.removeClass('active');

				}

			})
			.find('.input, input')
				.on('click', function (event) {

					event.preventDefault();
					event.stopPropagation();

				})
				.filter('input')
					.on('send', function () {

						if ($.trim($(this).val()) !== '')	window.location.href	=	$header.find('.search')[0].href + '?s=' + encodeURIComponent($.trim($(this).val()));
						//if ($.trim($(this).val()) !== '')	window.location.href	=	$header.find('.search')[0].href + '?s=' + encodeURIComponent($.trim($(this).val())) + '&CSRF_TOKEN=' + encodeURIComponent($(this).closest('.search').find('[name=CSRF_TOKEN]').val()) + '&' + $(this).closest('.search').find('[name=CSRF_TOKEN]').next('input').attr('name') + '=' + encodeURIComponent($(this).closest('.search').find('[name=CSRF_TOKEN]').next('input').val());

					})
					.on('keydown', function (event) {

						if (event.which === 13)	$(this).trigger('send');

					});

	$(document)
		.on('click', function (event) {

			$header
				.find('.search')
					.removeClass('active');

			//$header
			//	.find('.pepvalidate-v3')
			//		.removeClass('active');

		});

	//mobile menu links to reservations and passport login
	nav.element
		.find('.nav-link')
			.filter('.wifi')
				.on('click', function (event) {

					event.preventDefault();

					window.location.href	=	'http://portal.peppermillcas.com/';

				});

	$(function () {

		ajaxLinkRegisterCallback(
			'SSL-WARNING',
			function () {

				$('body')
					.children('.confirm')
						.filter('.dialog')
							.trigger('close');

				//track button click
				pepTracking.event('SSL Warning', 'Continue Anyway', 'User opted to ignore warning');

				//reset SSL Warning flag
				sslNotifyShow	=	false;

				//continue with attempting to book... godspeed
				$header
					.find('.pepvalidate-v3')
						.filter('.reservations')
							.trigger('submit');

			}
		);

		function reservationWidgetShowErrorMsg(msg, title, sslWarning) {

			if (typeof msg !== 'string' || msg.length === 0)	return;
			if (typeof title !== 'string')						var title		=	'';
			if (typeof sslWarning !== 'boolean')				var sslWarning	=	false;

			//close any current dialogs
			$('.dialog')
				.filter('.confirm')
					.filter('.active')
						.trigger('close');

			showOverlayDialog({
				alertMode				:	!sslWarning,
				confirmAccept			:	(sslWarning)	?	'Continue Anyway'	:	'OK',
				confirmCancel			:	(sslWarning)	?	'CANCEL'			:	'',
				confirmTitle			:	(title.length)	?	title				:	'',
				confirmBody				:	msg,
				callback				:	(sslWarning)	?	'SSL-WARNING'		:	''
			}, this);

		}

		//manually handle the reservation widget form submissions
		ajaxLinkRegisterCallback(
			'PRIVLINE-ACCOUNT-CODE',
			function (callbackData) {
				$('body')
					.children('.confirm')
					.filter('.dialog')
					.trigger('close');

				if (typeof callbackData.dataOBJ.offer_code === 'string' && ($.trim(callbackData.dataOBJ.offer_code).toUpperCase() === 'PRIVLINE' || $.trim(callbackData.dataOBJ.offer_code).toUpperCase() === 'PLBAKER') && $.trim(callbackData.dataOBJ.lmsref).length > 0) {

					//$header
					//	.find('.pepvalidate-v3')
					//		.filter('.reservations')
					//			.addClass('loading');

					var gaLinker	=	pepTracking.getGALinkerParam();
					var params		=	{
							o		:	callbackData.dataOBJ.offer_code,
							lmsref	:	callbackData.dataOBJ.lmsref
						};

					//add ga linker param
					if (gaLinker.length > 0)	params._ga		=	gaLinker;

					//redirect to the offer page
					window.location	=	'/offers/?' + $.param(params);

				} else {

					showOverlayDialog({
						alertMode		:	true,
						confirmAccept	:	'OK',
						confirmTitle	:	'Invalid Company Code',
						confirmBody		:	'Please enter a valid company code to continue.',
						overlayType: ''
					}, this);

				}

			}
		);

		ajaxLinkRegisterCallback(
			'HOTEL-OFFER-CODE',
			function (callbackData) {
				$('body')
					.children('.confirm')
					.filter('.dialog')
					.trigger('close');

				if (typeof callbackData.dataOBJ.offer_code === 'string' && ($.trim(callbackData.dataOBJ.offer_code).toUpperCase() === 'PRIVLINE' || $.trim(callbackData.dataOBJ.offer_code).toUpperCase() === 'PLBAKER')) {

					showLoader(false);

					//force the user to enter a Reference ID for the PRIVLINE offer
					showOverlayDialog({
						confirmAccept	:	'OK',
						confirmDeny		:	'CANCEL',
						confirmTitle	:	'Enter Account Code',
						confirmBody		:	'Please enter your company\'s Private Line account code.</p><form class="pepvalidate-v3"><p><label><span class="text">Account Code</span><input type="email" name="lmsref" /><input name="offer_code" type="hidden" value="' + callbackData.dataOBJ.offer_code.replace(/[^0-9a-z]/gi, '') + '" /></form><p>&nbsp;',
						callback		:	'PRIVLINE-ACCOUNT-CODE',
						overlayType: ''
					}, this);

				} else {

					showOverlayDialog({
						alertMode		:	true,
						confirmAccept	:	'OK',
						confirmTitle	:	'Invalid Offer Code',
						confirmBody		:	'Please enter a valid offer code to continue.',
						overlayType: ''
					}, this);

				}

			}
		);

		$('#header-static')
			.find('.reservation')
				.on('click', function (event) {

					if (sslNotifyShow) {

						event.preventDefault();

						reservationWidgetShowErrorMsg('Your browser is out-of-date and no longer secure. To protect your information please use a newer browser or call the following phone number to book your reservation:</p><p>1-866-821-9996', 'SSL Warning', true);

						$.ajax({
							url		:	'/library/api/ssl-notify-errors.php',
							type	:	'post',
							data	:	{
								'page'	:	window.location.href
							},
							success	:	function () {},
							error	:	function (jqXHR, textStatus, errorThrown) {

								//log this error
								var extraText	=	(typeof errorThrown === 'string')
														?	' -- ' + errorThrown
														:	'';
								pepTracking.event('JS Error', 'SSL Notify Logging AJAX', textStatus + extraText, 0, true);

							}
						});

					} else {

						//track this event
						pepTracking.event('Reservations Header', 'Get Rates Clicked', window.location.pathname, 0, false);

					}

				})
			.end()
			.find('.hotel-offer')
				.add('#header .hotel-offer')
				.on('click', function (event) {
					event.preventDefault();
					event.stopPropagation();
					showLoader();
					showOverlayDialog({
						confirmAccept	:	'OK',
						confirmDeny		:	'CANCEL',
						confirmTitle	:	'Enter Offer Code',
						confirmBody		:	'Please enter an offer code.</p><form class="pepvalidate-v3"><p><label><span class="text">Offer Code</span><input name="offer_code" type="text" value="" /></form><p>&nbsp;',
						callback		:	'HOTEL-OFFER-CODE',
						overlayType: ''
					}, this);
				});

		//Check if the user can connect to SUGAR
		var sslNotifyCookie	=	document.cookie.replace(/(?:(?:^|.*;\s*)ssl-notify\s*\=\s*([^;]*).*$)|^.*$/, "$1") || '{"ok":"no","time":0}',
			sslNotifyObj	=	$.parseJSON(sslNotifyCookie),
			sslNotifyShow	=	false,
			sslNotifyFunc	=	function () {

				$.ajax({
					url				:	'https://reserve1.peppermillcas.com:4323/misc/check-secure-connection.js',
					dataType		:	'jsonp',
					jsonpCallback	:	'cscCallback',
					timeout			:	15000,
					success			:	function () {

						//only check once an hour if a connection was successfully made
						sslNotifyShow	=	false;

						if (cookieData)	document.cookie	=	'ssl-notify={"ok":"yes","time":' + new Date().getTime() + '}; path=' + cookieData.b + cookieData.s + '; ' + cookieData.h;

					},
					error		:	function (a, b, c) {

						sslNotifyShow	=	true;

						if (cookieData)	document.cookie	=	'ssl-notify={"ok":"no","time":' + new Date().getTime() + '}; path=' + cookieData.b + cookieData.s + '; ' + cookieData.h;

					}
				});

			};

		//backwards compatability
		if (typeof sslNotifyObj === 'number') {

			sslNotifyObj	=	{
				ok		:	'no',
				time	:	sslNotifyObj
			};

		}

		if (sslNotifyObj.time === 0) {

			//object was just initialized, no check has occured
			sslNotifyFunc();

		} else if (sslNotifyObj.ok === 'yes' && sslNotifyObj.time < (new Date().getTime() - 3600000)) {

			//object was created from cookie but the last check was over an hour ago
			sslNotifyFunc();

		} else if (sslNotifyObj.ok === 'no') {

			sslNotifyShow	=	true;

			if (sslNotifyObj.time < (new Date().getTime() - 100000)) {

				//object was created from cookie and the last check failed but it was checked over five minutes ago
				sslNotifyFunc();

			}

		}

	});















	//do all window.resize code
	var resizeTimer			= null,
		iresizetimer		= null,
		loadFired			= false;

	$(window).on("resize.all load.all orientationchange.all", function (event) {

		//update saved viewport dimensions
		dims.window.w	= $(window).width();
		dims.window.h	= $(window).height();

		responsive.update();

	}).trigger("resize.all");







	//Text Size Code
	$("#container").on("click", ".text-size-btn", function (event) {

		event.preventDefault();

		//var now			=	new Date(),
		//	expire		=	new Date(now.getTime() + (parseInt(cookieData.timeout, 10) * 10000));

		if (!$("html").hasClass("text-increase")) {
			//go big
			$("html").addClass("text-increase");

			if (cookieData)	document.cookie = 'text-size=text-increase; path=' + cookieData.b + cookieData.s + '; ' + cookieData.h;

			pepTracking.event('Text Size', 'Increase', window.location.pathname, 0, false);
		} else {
			//go normal
			$("html").removeClass("text-increase");

			if (cookieData)	document.cookie = 'text-size=; path=' + cookieData.b + cookieData.s + '; ' + cookieData.h;

			pepTracking.event('Text Size', 'Normal', window.location.pathname, 0, false);
		}

		//force redraw
		$(window).trigger("resize");

	});


  //setup GA tracking code
  window.pepTracking = {
    page: function (customPage) {
      if (typeof gtag === 'undefined') return;

      if (typeof customPage === 'string' && customPage !== '') {
        gtag('event', 'page_view', {
          page: customPage
        });
      }
    },
    event: function (category, action, extra, value, ni) {

      if (typeof gtag === 'undefined') return;

      if (typeof category !== 'string') category = 'N/A';

      if (typeof action !== 'string') action = 'N/A';

      if (typeof extra !== 'string') extra = 'N/A';

      if (typeof value !== 'number') value = 0;

      if (typeof ni !== 'boolean') ni = false;

      gtag('event', action, {
        hitType: 'event',
        event_category: category,
        event_action: action,
        event_label: extra,
        nonInteraction: ni,
        transport: 'beacon',
        value: value
      });

    },
    getGALinkerParam: function () {
      //get GA (UA) tracker param//get GA tracker param
      var output = '',
        anchorEle = $('<a href="/"></a>')[0];

      if (typeof anchorEle === 'object' && typeof ga !== 'undefined') {

        ga('linker:decorate', anchorEle);

        if (typeof anchorEle.search === 'string') {

          if (anchorEle.search.replace('?', '').substr(0, 4) === '_ga=') {

            output = anchorEle.search.replace('?', '').substr(4);

          }

        }

      }

      return output;
    },
    getGA4LinkerParam: function () {
      //get GA4 tracker param

      const formNode = document.createElement('FORM');
      formNode.action = (window.pepConsole.isDev) ? 'https://devbooking.peppermillreno.com/' : 'https://booking.peppermillreno.com/';
      formNode.style.opacity = '0';
      formNode.addEventListener('submit', (event) => {
        event.preventDefault();
      });

      const buttonNode = document.createElement('BUTTON');
      buttonNode.type = 'submit';
      formNode.append(buttonNode);

      document.body.append(formNode);

      buttonNode.click();

      const _glNode = formNode.querySelector('input[name="_gl"]');

      let output = '';
      if (_glNode) {
        output = _glNode.value;
      }

      formNode.remove();

      return output;
    }
  };

	$("#container").on("click", '.track-click', function () {
		pepTracking.page($(this).attr('href'));
	});

	//find links that go to the /choose-a-room/ or /offers/ pages and add GA linker data to them
	$.each($('a'), function () {

		if (this.href.indexOf(window.location.protocol + '//' + window.location.hostname + '/offers') === 0 || this.href.indexOf(window.location.protocol + '//' + window.location.hostname + '/choose-a-room') === 0) {

			if (typeof ga !== 'undefined')	ga('prod.linker:decorate', this);

		}

	});









	//set datepicker options
	if (typeof $.fn.datepicker !== 'undefined') {

		$.fn.datepicker.language['en'] = {
			days		:	['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
			daysShort	:	['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
			daysMin		:	['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
			months		:	['January','February','March','April','May','June', 'July','August','September','October','November','December'],
			monthsShort	:	['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
			today		:	'Today',
			clear		:	'Clear',
			dateFormat	:	'mm/dd/yyyy',
			timeFormat	:	'hh:ii aa',
			firstDay	:	0
		};

	}









	//setup filters
	$(document)
		.on('click', function () {

			$('.page-link-filter')
				.find('.filter-type')
					.removeClass('show');

		});

	$.each($('.page-link-filter'), function () {

		var $filters		=	$(this).find('.filter-type'),
			$bodyContainers	=	$filters.closest('.page-content').find('.body-container').filter('.page-links'),
			$localPageLinks	=	$pageLinks,
			itemSelector	=	'.item',
			liHeight		=	$filters.eq(0).find('.display').height(),
			filters			=	$filters.map(function () {

				return $(this).data('name');

			}).get();

		//setup for calendar style filter if necessary
		if ($container.hasClass('calendar-page')) {

			var $bodyContainers		=	$('#calendar-wrapper')
				itemSelector		=	'.event',
				$localPageLinks		=	$bodyContainers.find('.event');

		}

		$(window)
			.on('load resize', function () {

				liHeight	=	$filters.eq(0).find('.display').height();

			});

		$(this)
			.find('.cancel')
				.on('click', function (event) {

					event.preventDefault();

					$(this)
						.siblings('.filter-type')
							.children('.flyout')
								.find('li')
									.eq(0)
										.trigger('click', [true]);

				});

		$filters
			.data({
				clickOK		:	true,
				clickTimer	:	null
			})
			.on('reset', function () {

				$(this)
					.children('.flyout')
						.find('li')
							.eq(0)
								.trigger('click', [true]);

			})
			.on('mouseenter', function () {

				var $filter	=	$(this);

				$filter
					.removeClass('hide')
					.data({
						clickOK		:	false,
						clickTimer	:	setTimeout(function () {

							$filter
								.data('clickOK', true);

						}, 250)
					});

			})
			.children('.display')
				.on('click', function (event) {

					event.stopPropagation();

					var $display	=	$(this);

					//determine which filter values can be hidden because they are not available as a combination now
					if (itemSelector === '.item') {

						var possibleFilterOptions	=	{};

						$.each($filters, function () {

							possibleFilterOptions[$(this).data('name')]	=	[];

						});

						$.each($localPageLinks.filter(function () { return !$(this).data('hide'); }), function () {

							var $pl	=	$(this);

							$.each(possibleFilterOptions, function (key, val) {

								if (typeof $pl.data(key) !== 'undefined') {

									if (typeof possibleFilterOptions[key][$pl.data(key)] === 'undefined')	possibleFilterOptions[key][$pl.data(key)]	=	1;
									else																	possibleFilterOptions[key][$pl.data(key)]++;

								}

							});

						});

						$.each(possibleFilterOptions, function (filterName, filterData) {

							$.each($filters.filter(function () { return $(this).data('name') === filterName; }).find('.flyout').find('li'), function () {

								if (typeof filterData[$(this).data('value')] !== 'undefined')	$(this).find('.count').text('(' + filterData[$(this).data('value')] + ')');
								else															$(this).find('.count').text('(0)')

								if ($(this).data('value') === '' || typeof filterData[$(this).data('value')] !== 'undefined') {

									$(this)
										.removeClass('disabled');

								} else {

									$(this)
										.addClass('disabled');

								}

							});

						});

						//TODO: choose whether or not to use the disabled class
						if (window.location.search.substr(0, 7) === '?test=2') {

							$filters
								.filter($display.closest('.filter-type'))
									.find('li')
										.removeClass('disabled');

						}

					}

					//position the filter options if necessary
					var $selected		=	$display.next().find('li').filter(function () { return $display.data('value') == $(this).data('value'); }),
						translateVal	=	(liHeight * -1 * ($selected.parent().children().not('.disabled').index($selected) + 1));

					//don't let the options hide under the header
					if (Math.abs(translateVal) > $display.closest('.filter-type').offset().top - currentScroll - ($header.outerHeight() + $header.position().top)) {

						translateVal	=	Math.round(($display.closest('.filter-type').offset().top - currentScroll - ($header.outerHeight() + $header.position().top)) * -1);

					}

					$display
						.next()
							.css({
								transform	:	'translateY(' + translateVal + 'px)'
							});

					//open this filter, close all others in this set
					$display
						.closest('.filter-type')
							.addClass('show')
							.closest('.filter-wrapper')
								.siblings('.filter-wrapper')
									.children('.filter-type')
										.removeClass('show');

				})
			.end()
			.children('.flyout')
				.find('li')
					.on('click', function (event, forceClick) {

						event.stopPropagation();

						if (typeof forceClick !== 'boolean')	var forceClick	=	false;

						var $selected	=	$(this),
							$filter		=	$selected.closest('.filter-type'),
							$display	=	$filter.children('.display');

						if (!forceClick && !$filter.data('clickOK'))	return;

						if (!forceClick) {

							$filter
								.data({
									clickOK		:	false,
									clickTimer	:	setTimeout(function () {

										$filter
											.data('clickOK', true);

									}, 350)
								});

						}

						//only do work if the value changed
						if ($selected.data('value') !== $display.data('value')) {

							//show/hide the cancel button
							if ($selected.data('value') === '') {

								$filter
									.siblings('.cancel')
										.removeClass('show');

							} else {

								$filter
									.siblings('.cancel')
										.addClass('show');

							}

							//update .selected
							$selected
								.addClass('selected')
									.siblings()
										.removeClass('selected');

							//update filter value
							var translateVal	=	(liHeight * -1 * ($selected.parent().children().not('.disabled').index($selected) + 1));

							//don't let the options hide under the header
							if (Math.abs(translateVal) > $selected.closest('.filter-type').offset().top - currentScroll - $header.outerHeight()) {

								translateVal	=	Math.round(($selected.closest('.filter-type').offset().top - currentScroll - $header.outerHeight()) * -1);

							}

							$display
								.data('value', $selected.data('value'))
								.text($selected.clone(true).find('span').remove().end().text())
								.next()
									.css({
										transform	:	'translateY(' + translateVal + 'px)'
									});

							//get all the filter values
							var filterValues	=	$filters.map(function () {

									return $(this).children('.display').data('value');

								}).get();

							//find all matches
							var $matches	=	$localPageLinks
													.filter(function () {

														if (itemSelector === '.item') {

															for (var i = 0, l = filters.length; i < l; i++) {

																if (filterValues[i] != '' && $(this).data(filters[i]) != filterValues[i])	return false;

															}

															return true;

														} else {

															//check for the "more" buttons or when no filter is chosen
															if ($(this).hasClass('more') || $display.data('value') === '')	return true;

															//calendar filter
															var eventFilters	=	($(this).data('cats').indexOf('|') > -1)
																						?	$(this).data('cats').split('|')
																						:	[$(this).data('cats')];

															for (var i = 0, l = filters.length; i < l; i++) {

																if (filterValues[i] != '' && $.inArray(filterValues[i], eventFilters) > -1)	return true;

															}

															return false;

														}

													});

							//make sure matches are visible
							$matches
								.each(function () {

									var $match	=	$(this);

									$match
										.addClass('hide')
										.removeClass('hidden');

									setTimeout(function () {

										$match
											.removeClass('hide');

									}, 50);

								})
								.data({
									hide	:	false
								});

							//hide page links that don't match
							$localPageLinks
								.not($matches)
									.each(function () {

										var $match	=	$(this);

										setTimeout(function () {

											$match
												.addClass('hidden')
												.removeClass('hide');

										}, 300);

										$match
											.addClass('hide');

									})
									.data({
										hide	:	true
									});

							//fix match classes
							if (itemSelector === '.item') {

								$localPageLinks
									.removeClass('item-second item-third')
									.removeClass(function (index, css) {

										return (css.match(/(^|\s)item-\d+/g) || []).join(' ');

									});

								$.each($bodyContainers, function (i) {

									$bodyContainers
										.eq(i)
											.find(itemSelector)
												.filter(function () {

													return !$(this).data('hide');

												})
													.each(function (j) {

														var index	=	j + 1;

														$(this).addClass('item-' + index);

														if (index % 2 === 0)	$(this).addClass('item-second');
														if (index % 3 === 0)	$(this).addClass('item-third');

													});

								});

								clearTimeout(pageLinkResizetimer);
								pageLinkResizetimer	=	setTimeout(recalcPageLinks, 325);

								//find all .page-containers without any visible page links

								var noMatchContainers	=	$bodyContainers
																.removeClass('no-matches-found')
																.filter(function () {

																	return $(this).find('.item').filter(function () {  return !$(this).data('hide'); }).length === 0;

																})
																	.addClass('no-matches-found').length;

								if (noMatchContainers === $bodyContainers.length) {

									//no matches found at all, let the user know
									pepNotify.show(5000, 'No matches found. Remove the last filter?', '', 'REMOVE', null, function () { $filter.trigger('reset'); }, false);

								} else if ($('#notifications').find('.notification').length) {

									$.each($('#notifications').find('.notification'), function () {

										pepNotify.close($(this));

									});

								}

							}

						}

						//hide on every click, even if the value does not change
						$filter
							.removeClass('show');

					});

	});









	/*SETUP HOTEL RATE FLYOUT BUTTONS*/
	var reserveRatesLiHeight	=	$('.reserve-rates').eq(0).find('.display').height();

	$(document)
		.on('click', function () {

			$container
				.find('.reserve-rates')
					.removeClass('show');

		});

	$(window)
		.on('load resize', function () {

			reserveRatesLiHeight	=	$('.reserve-rates').eq(0).find('.display').height();

		});

	function initReserveRates() {

		var $rateBtn	=	$(this);

		if ($rateBtn.data('initialized'))	return;

		$rateBtn
			.data({
				initialized	:	true,
				clickOK		:	true,
				clickTimer	:	null,
				hoverTimer	:	null
			})
			.on('reset', function () {

				$(this)
					.children('.flyout')
						.find('li')
							.eq(0)
								.trigger('click', [true]);

			})
			.on('mouseenter', function () {

				$rateBtn
					.removeClass('hide')
					.data({
						clickOK		:	false,
						clickTimer	:	setTimeout(function () {

							$rateBtn
								.data('clickOK', true);

						}, 250)
					});

			})
			.on('mouseleave', function () {

				if (!Modernizr.touchevents) {

					clearTimeout($rateBtn.data('hoverTimer'));

					$(this)
						.closest('.reserve-rates')
							.removeClass('show');

				}

			})
			.children('.display')
				.on('mouseenter', function () {

					if (!Modernizr.touchevents) {

						var $display	=	$(this);

						clearTimeout($rateBtn.data('hoverTimer'));

						$rateBtn
							.data('hoverTimer', setTimeout(function () {

								$display
									.trigger('click.reserve-rates');

							}, 150));

					}

				})
				.on('click.reserve-rates', function (event) {

					event.stopPropagation();

					//only if a link does not exist
					if ($(this).find('a').length === 0) {

						//open this flyout, close all others in this set
						$(this)
							.closest('.reserve-rates')
								.addClass('show')
								.closest('.item')
									.siblings('.hotel')
										.find('.reserve-rates')
											.removeClass('show');

					}

				})
			.end()
			.children('.flyout')
				.css({
					transform	:	'translateY(' + (-1 * reserveRatesLiHeight * ($rateBtn.find('.flyout').find('.selected').index() + 1)) + 'px)'
				})
				.find('li')
					.on('click', function (event, forceClick) {

						event.stopPropagation();

						if (typeof forceClick !== 'boolean')	var forceClick	=	false;

						var $selected	=	$(this),
							$display	=	$rateBtn.children('.display');

						if (!forceClick && !$rateBtn.data('clickOK'))	return;

						if (!forceClick) {

							$rateBtn
								.data({
									clickOK		:	false,
									clickTimer	:	setTimeout(function () {

										$rateBtn
											.data('clickOK', true);

									}, 350)
								});

						}

						//only do work if the value changed
						if ($selected.data('value') !== $display.data('value')) {

							//update .selected
							$selected
								.addClass('selected')
									.siblings()
										.removeClass('selected');



						}

					})
					.find('a')
						.on('click', function () {

							if ($rateBtn.hasClass('menus')) {

								pepTracking.event('Menu Click', $('h1').text(), $(this).text(), 0, true);

							} else {

								//get title of this room
								var title	=	($rateBtn.closest('.item').length)
													?	$rateBtn.closest('.item').find('h3').text()
													:	$('h1').text();

								pepTracking.event('Reservations Room Rate Click', title, '', 0, true);

							}

						});

	}

	$.each($container.find('.reserve-rates'), initReserveRates);









	/*$.each($('.page-link-filter'), function () {

		var $filters		=	$(this).find('select'),
			$bodyContainers	=	$filters.closest('.page-content').find('.body-container').filter('.page-links'),
			$pageLinks		=	$bodyContainers.find('.item');

		$filters
			.on('change', function () {

				//get all filter values
				var filters	=	[];

				$.each($filters, function (i) {

					if ($filters[i].value !== '')	filters.push([$filters[i].name, $filters[i].value]);

				});


				//find all matches
				var $matches	=	$pageLinks
										.filter(function () {

											for (var i = 0, l = filters.length; i < l; i++) {

												if ($(this).data(filters[i][0]) != filters[i][1])	return false;

											}

											return true;

										});

				//make sure matches are visible
				$matches
					.removeClass('hide hidden');

				//hide page links that don't match
				$pageLinks
					.not($matches)
						.each(function () {

							$(this)
								.onCSSTransitionEnd(function () {

									$(this)
										.addClass('hidden')
										.removeClass('hide');

								})
								.addClass('hide');

						});

				//fix match classes
				$pageLinks
					.removeClass('item-second item-third');

				$.each($bodyContainers, function (i) {

					$bodyContainers
						.eq(i)
							.find('.item')
								.not('.hide')
									.not('.hidden')
										.each(function (j) {

											if ((j + 1) % 2 === 0)	$(this).addClass('item-second');
											if ((j + 1) % 3 === 0)	$(this).addClass('item-third');

										});

				});

				//find all .page-containers without any visible page links
				$bodyContainers
					.removeClass('no-matches-found')
					.filter(function () {

						return $(this).find('.item').not('.hide').not('.hidden').length === 0;

					})
						.addClass('no-matches-found');

				//remove all filter options that don't exist with the current filters
				if ($pageLinks.length !== $matches.length) {

					var filtersToCheck	=	[];

					$.each($filters, function (i) {

						if ($filters[i].value === '')	filtersToCheck.push($filters[i].name);

					});

					for (var i = 0, l = filtersToCheck.length; i < l; i++) {

						//get all available options for this filter from $matches
						var availableOptions	=	$matches.map(function () {

								return $(this).data(filtersToCheck[i]);

							});

						$filters
							.filter(function () {

								return this.name === filtersToCheck[i];

							})
								.find('option')
									.filter(function () {

										return this.value !== '' && $.inArray(this.value, availableOptions) === -1;

									})
										.remove();

					}

				}

			});


	});*/









	//SETUP NOTIFICATIONS
	window.pepNotify	=	{
		ele			:	$('#notifications'),
		viewport	:	$('#notifications').children('.viewport'),
		show		:	function (duration, msg, type, actionText, actionLink, callback, forceClose) {

			if (typeof forceClose !== 'boolean')	var forceClose	=	false;

			//make sure this notification doesn't already exist
			var $match	=	pepNotify.viewport.children('.notification').filter(function () {

					var data	=	$(this).data();

					return (data.duration === duration && data.msg === msg && data.type === type && data.actionText === actionText && data.actionLink === actionLink);

				});

			if ($match.length) {

				if ($match.find('.count').length === 0) {

					$match.append('<span class="count">2</span>');

					setTimeout(function () {

						$match
							.find('.count')
								.onCSSAnimationEnd(function () {

									$(this).removeClass('bounce');

								})
								.addClass('show bounce');

					}, 50);

				} else {

					$match
						.find('.count')
							.text(parseInt($match.find('.count').text(), 10) + 1)
							.onCSSAnimationEnd(function () {

								$(this).removeClass('bounce');

							}).addClass('bounce');

				}

				pepNotify.reset($match);

				return;

			}

			var $ele	=	$(pepNotify.buildHTML(msg, type, actionText, actionLink, callback))
								.data({
									duration		:	duration,
									msg				:	msg,
									type			:	type,
									actionText		:	actionText,
									actionLink		:	actionLink,
									callback		:	callback,
									forceClose		:	forceClose
								});

			$ele
				.on('mouseenter', function () {

					if ($ele.hasClass('closing')) return;

					if (!$ele.data('forceClose'))	clearTimeout($ele.data('timer'));

					$ele.addClass('hover');

				})
				.on('mouseleave', function () {

					pepNotify.activate($ele);

					$ele.removeClass('hover');

				})
				.find('.action')
					.on('click', function (event) {

						if ($(this).hasClass('close') || $(this).attr('href') === '#')	event.preventDefault();

						$ele.removeClass('hover').addClass('closing');

						pepNotify.close($ele, true);

					});

			pepNotify.viewport.append($ele);

			if (pepNotify.viewport.children('.notification').filter('.active').length === 0) {

				setTimeout(function () {

					pepNotify.activate($ele);

				}, 50);

			}

		},
		close		:	function ($ele, closeFromClick) {

			if (typeof closeFromClick !== 'boolean')	var closeFromClick	=	false;

			pepNotify.ele.onCSSTransitionEnd(function () {

				if (!$ele.data('forceClose') && $ele.hasClass('hover') && !$ele.hasClass('closing'))	return;

				if (typeof $ele.data('callback') === 'function' && (closeFromClick || $ele.data('forceClose')))	{

					$ele.data('callback')();

				}

				$ele.remove();

				pepNotify.rotate();

			}).removeClass('show');

			$('html').removeClass('show-notify');

		},
		reset		:	function ($ele) {

			clearTimeout($ele.data('timer'));

			$ele.data('timer', setTimeout(function () {

				pepNotify.close($ele);

			}, $ele.data('duration')));

		},
		activate	:	function ($ele) {

			if ($ele.hasClass('closing'))	return;

			pepNotify.ele.addClass('show');

			$('html').addClass('show-notify');

			$ele.addClass('active').data('timer', setTimeout(function () {

				pepNotify.close($ele);

			}, $ele.data('duration')));

		},
		rotate		:	function () {

			var $notifications	=	pepNotify.viewport.children('.notification');

			if ($notifications.length > 0 && $notifications.filter('.active').length === 0) {

				pepNotify.activate($notifications.eq(0));

			}

		},
		buildHTML	:	function (msg, type, actionText, actionLink, actionCallback) {

			var html	=	'<div class="notification" role="status"><table class="no-zebra"><tbody><tr><td class="content">';

			if (typeof type === 'string')	html	+=	'<span class="material-icons">' + type + '</span> ';

			html	+=	msg + '</td><td class="action-cell">';

			if (typeof actionText === 'string' && (typeof actionLink === 'string' || typeof actionCallback === 'function'))	{

				if (typeof actionLink !== 'string')	var actionLink	=	'#';

				html	+=	'<a class="action" href="' + actionLink + '">' + actionText + '</span>';

			} else {

				html	+=	'<a class="action close" href="#">HIDE</span>';

			}

			html	+=	'</td></tr></table></div>';

			return html;

		}
	};









	/*PRELOAD IMAGES*/
	$(window).on("load", function () {

		var preloadImages	= $('#image-preload').data('images')	||	[];

		for (var i = 0, l = preloadImages.length; i < l; i++) {

			$("<img />")[0].src	= preloadImages[i];

		}

	});









	$(function () {

		if ('pepvalidateRegisterCallback' in window) {

			//setup a generic callback for showing a pepNotify notification
			window.pepvalidateRegisterCallback(
				'GENERIC-FORM-NOTIFICATION',
				function (msg, icon, duration) {

					if (typeof icon !== 'string')			icon		=	'';
					if (typeof duration === 'undefined')	duration	=	10000;

					pepNotify.show(duration, msg, icon);

					$(this)
						.removeClass('loading');

				}
			);

			//SETUP PASSPORT LOGIN CALLBACKS

			window.pepvalidateRegisterCallback(
				'PASSPORT-HEADER-LOGIN-SUCCESS',
				function (redirect, rememberMe) {

					var rm	=	(rememberMe)
									?	'Remember Me'
									:	'Standard';

					pepTracking.event('Players Club', 'Login Success', rm, 0, true);

					setTimeout(function () {

						window.location.href	=	redirect;

					}, 50);

				}
			);

			window.pepvalidateRegisterCallback(
				'PASSPORT-HEADER-LOGIN-ERROR',
				function (msg) {

					pepTracking.event('Players Club', 'Login Failure', msg, 0, true);

					pepNotify.show(10000, msg, 'error');

					$(this)
						.removeClass('loading');

				}
			);

			window.pepvalidateRegisterCallback(
				'PASSPORT-HEADER-LOGOUT-SUCCESS',
				function () {

					pepNotify.show(10000, 'You are now logged out.', 'done');

				}
			);

			//SETUP GENERIC FORMS
			setTimeout(function () {

				$.each($container.find('.pepvalidate-v3'), pepvalidateInitForm);

			}, 50);

		}

	});









	//Check if Sprites Have Been Loaded
	if ('localStorage' in window) {

		$(function () {

			//first load from cookie
			var spriteCookie	=	document.cookie.replace(/(?:(?:^|.*;\s*)pepsprites\s*\=\s*([^;]*).*$)|^.*$/, "$1"),
				spritesLoaded	=	[],
				cookieSprites	=	(spriteCookie === '')
										?	[]
										:	(spriteCookie.indexOf(',') > -1)
											?	spriteCookie.split(',')
											:	[ spriteCookie ];

			function saveLoadedSprites() {

				var $sprites		=	$('body').children('.system-sprite'),
					loadedSprites	=	[],
					expiresDate		=	new Date();

				//expire in 15 minutes
				expiresDate.setTime(new Date().getTime() + 900000);

				$.each($sprites, function (i) {

					try {

						localStorage.setItem('sprite-' + $sprites.eq(i).attr('id'), $sprites.eq(i).prop('outerHTML'));

						loadedSprites.push($sprites.eq(i).attr('id'));

					} catch (e) {}
				});

				if (cookieData)	document.cookie = 'pepsprites=' + loadedSprites.join(',') + '; expires=' + expiresDate.toGMTString() + '; path=' + cookieData.b + cookieData.s + '; ' + cookieData.h;

			}

			for (var i = 0, l = cookieSprites.length; i < l; i++) {

				var spriteHTML	=	localStorage.getItem('sprite-' + cookieSprites[i]);

				if (typeof spriteHTML === 'string' && spriteHTML.length > 0 && $('#' + cookieSprites[i]).length === 0) {

					$('body')
						.append(spriteHTML);

					spritesLoaded.push(cookieSprites[i]);

				}

			}

			var $sprites		=	$('body').children('.system-sprite');

			$.each($sprites, function (i) {

				try {

					localStorage.setItem('sprite-' + $sprites.eq(i).attr('id'), $sprites.eq(i).prop('outerHTML'));

					spritesLoaded.push($sprites.eq(i).attr('id'));

				} catch (e) {}
			});

			//check the difference between the cookieSprites array and the spritesLoaded array, to load any necessary sprites over AJAX
			for (var i = 0, l = cookieSprites.length; i < l; i++) {

				if (spritesLoaded.indexOf(cookieSprites[i]) === -1) {

					(function (inner_i) {

						//this cookie sprite could not be loaded from localStorage and it was not included in the page output
						$.ajax({
							url			:	'/library/html/templates/' + cookieSprites[inner_i] + '.svg',
							type		:	'get',
							dataType	:	'html',
							success		:	function (response) {

								if (typeof response === 'string' && response.substr(0, 5) === '<svg ' && $('#' + cookieSprites[inner_i]).length === 0) {

									$('body')
										.append(response);

									saveLoadedSprites();

								}

							}
						});

					})(i);

				}

			}

			saveLoadedSprites();

		});

	}








	/*
	//look to see if we need to gather room rate data
	var $hotelPageLinks		=	$('.page-links').find('.item').filter('.hotel'),
		$hotelPageRates		=	$('.right-side-content').find('.reserve-rates').not('.menus'),
		hotelPageLinkIDs	=	[],
		roomRateDataTTL		=	300000;//5 minutes

	function parseRoomRateData(response) {

		if (response.STATUS === 'SUCCESS') {

			for (var i = 0, l = response.DATA.length; i < l; i++) {

				//create HTML for this data
				var rateHTML	=	'<ul class="reserve-rates"><li class="display" data-value=""><span>' + response.DATA[i].LOW_RATE + '</span></li><li class="flyout"><ul>';

				for (var j = 0, m = response.DATA[i].RATES.length; j < m; j++) {

					var price	=	(response.DATA[i].RATES[j].PRICE !== '')
										?	'$' + response.DATA[i].RATES[j].PRICE + ', '
										:	'';

					rateHTML	+=	'<li' + response.DATA[i].RATES[j].SELECTED + '><a href="' + response.DATA[i].RATES[j].LINK + '">' +price + response.DATA[i].RATES[j].DISPLAY + '</a></li>';

				}

				rateHTML	+=	'</ul></li></ul>';

				var $matches	=	$hotelPageLinks
										.filter(function (j) {

											return parseInt($hotelPageLinks.eq(j).data('page-id'), 10) === parseInt(response.DATA[i].PAGE_ID, 10);

										})
											.find('.reserve-rates')
												.replaceWith(rateHTML);

				if ($hotelPageRates.length && parseInt(response.DATA[i].PAGE_ID, 10) === parseInt($('body').data('i'), 10))	$hotelPageRates.replaceWith(rateHTML);

			}

			$.each($('.reserve-rates'), initReserveRates);

			//cache this data
			if ('localStorage' in window) {

				response.TIMESTAMP	=	new Date().getTime();

				try {

					localStorage.setItem('room-rate-data', JSON.stringify(response));

				} catch (e) {}
			}

		}

	}

	if ($hotelPageLinks.length || $hotelPageRates.length) {

		$.each($hotelPageLinks, function (i) {

			hotelPageLinkIDs.push($hotelPageLinks.eq(i).data('page-id'));

		});

		hotelPageLinkIDs.push($hotelPageRates.closest('body').data('i'));

		if (hotelPageLinkIDs.length > 0) {

			//first look to see if data has been cached
			var roomRateData	=	null;

			if ('localStorage' in window) {

				roomRateData	=	localStorage.getItem('room-rate-data');

				if (roomRateData) {

					roomRateData	=	JSON.parse(roomRateData);

					if (roomRateData.TIMESTAMP < new Date().getTime() - roomRateDataTTL) {

						localStorage.removeItem('room-rate-data');

						roomRateData	=	null;

					} else if (typeof Array.prototype.filter === 'function') {

						//determine if any IDs on the current page are not in the stored data
						var idsWeHave		=	$.map(roomRateData.DATA, function (obj) {

								return obj.PAGE_ID;

							}),
							idsStillNeeded	=	hotelPageLinkIDs.filter(function (id) {

								return idsWeHave.indexOf(id) !== -1;

							});

						console.log(idsWeHave);
						console.log(idsStillNeeded);

					}

				}

			}

			if (roomRateData) {

				parseRoomRateData(roomRateData);

			} else {

				$.ajax({
					url			:	'/library/api/room-rates.php',
					type		:	'post',
					dataType	:	'json',
					data		:	{
						ACTION	:	'GET_ROOM_RATES',
						ROOMS	:	hotelPageLinkIDs
					},
					success		:	parseRoomRateData
				});

			}

		}

	}
	*/








	//SETUP TABLE INTERACTIONS
	$('.table-pagination')
		.find('.material-icons')
			.filter('.disabled')
				.on('click', function (event) {

					event.preventDefault();

				})
			.end()
		.end()
		.find('select[name=ROWS_PER_PAGE]')
			.on('change', function () {

				if ($(this).val() === '')	return;

				var linkData	=	$(this).closest('.table-pagination').data();

				window.location	=	window.location.pathname + '?SORT_COL=' + linkData.sortCol + '&SORT_DIR=' + linkData.sortDir + '&ROWS_PER_PAGE=' + $(this).val() + '&ROW_OFFSET=' + linkData.rowOffset + '&' + linkData.searchKey + '=' + linkData.searchVal;

			});


  //listen for related events embed messages
  const $relatedEventsFrame = $('.related-events-frame');
  const originToCheck = location.origin;

  if ($relatedEventsFrame.length) {
    if ('postMessage' in window) {
      window
        .addEventListener('message', function (event) {
          let origin = event.origin;
          let data = event.data;
          if (typeof event.originalEvent !== 'undefined') {
            // For Chrome, the origin property is in the event.originalEvent object.
            origin = event.originalEvent.origin;
            data = event.originalEvent.data;
          }

          //is trusted removed since this is scripted, not initiated by user interaction
          if (origin.substring(0, originToCheck.length) === originToCheck) {
            const dataObj = (typeof data === 'object') ? data : JSON.parse(data);
            if (dataObj && dataObj.pageheight) {
              $relatedEventsFrame
                .css({
                  height: parseInt(dataObj.pageheight, 10),
                  overflow: 'hidden'
                });
            }
          }
        }, false);
    } else {
      //postmessage fallback
      $relatedEventsFrame
        .css({
          height: 1000
        });
    }
  }
})();